// CollabbayDashboard.js
import React, { useEffect, useMemo, useRef, useState } from "react";
import { useNavigation } from "@react-navigation/native";

// ✅ Show follower range (always, even for subscribed brands)
const getFollowerRange = (num) => {
  const n = Number(num) || 0;
  if (n < 2000) return "Under 2K Followers";
  if (n < 5000) return "2K–5K Followers";
  if (n < 10000) return "5K–10K Followers";
  if (n < 20000) return "10K–20K Followers";
  if (n < 50000) return "20K–50K Followers";
  if (n < 100000) return "50K–100K Followers";
  if (n < 200000) return "100K–200K Followers";
  if (n < 500000) return "200K–500K Followers";
  if (n < 1000000) return "500K–1M Followers";
  return "1M+ Followers";
};

// ✅ Ensure we extract a pure number from strings like "12.3k" or "10,000"
const parseFollowers = (val) => {
  if (!val) return 0;
  let str = String(val).toLowerCase().trim();
  if (str.endsWith("k")) return parseFloat(str) * 1000;
  if (str.endsWith("m")) return parseFloat(str) * 1000000;
  return parseInt(str.replace(/[^0-9]/g, ""), 10) || 0;
};

export default function CollabbayDashboard(props) {
  let { navigation } = props || {};
  // Fallback if this component is ever rendered without a nav prop
  if (!navigation?.navigate) {
    navigation = useNavigation();
  }

  // ------------------------------
  // Global state
  // ------------------------------
  const [userData, setUserData] = useState({});
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isSubscriber, setIsSubscriber] = useState(false);

  const [planStatusLoaded, setPlanStatusLoaded] = useState(false);
  
  const [errorMessage, setErrorMessage] = useState("");

  const [venueCode, setVenueCode] = useState("");
  const [showLoginPrompt, setShowLoginPrompt] = useState(false);

  const [brandListings, setBrandListings] = useState([]);

  const [listingViewsById, setListingViewsById] = useState({});


  const [totalCollabCount, setTotalCollabCount] = useState(0);

  const [collabs, setCollabs] = useState([]);
  const [loadingCollabs, setLoadingCollabs] = useState(true);


const [showDummyBookingPrompt, setShowDummyBookingPrompt] = useState(false);
const [loadingDummyBookingPrompt, setLoadingDummyBookingPrompt] = useState(false);


  const [hidingCollabID, setHidingCollabID] = useState(null);

  const [recentOnline, setRecentOnline] = useState([]);
  const [recentCount, setRecentCount] = useState(0);

  const [suggestedUsers, setSuggestedUsers] = useState([]);
  const [loadingSuggested, setLoadingSuggested] = useState(false);

  const [ragItems, setRagItems] = useState([]);
  const [loadingRAG, setLoadingRAG] = useState(true);

  const IMAGE_BASE = "https://collabbayadmin.com/listings/";

  const [missedCollabs, setMissedCollabs] = useState([]);
  const [alertCollabs, setAlertCollabs] = useState([]);

  // Alert for “in-venue now”
  const [showCollabModal, setShowCollabModal] = useState(false);
  const [currentCollab, setCurrentCollab] = useState(null);

  // Venue code info modal
  const [showVenueCodeInfo, setShowVenueCodeInfo] = useState(false);

const [showSegmentModal, setShowSegmentModal] = useState(false);
const [segmentStep, setSegmentStep] = useState(1);
const [segmentQuality, setSegmentQuality] = useState("");
const [segmentRhythm, setSegmentRhythm] = useState("");
const [segmentSaving, setSegmentSaving] = useState(false);
const [segmentError, setSegmentError] = useState("");


const [showFreemiumPopup, setShowFreemiumPopup] = useState(false);
const [freemiumProofIndex, setFreemiumProofIndex] = useState(0);
const [freemiumCloseReady, setFreemiumCloseReady] = useState(false);



const [suggestedListing, setSuggestedListing] = useState(null);
const [showSuggestedListingModal, setShowSuggestedListingModal] = useState(false);
const [suggestedListingCloseReady, setSuggestedListingCloseReady] = useState(false);

const [showCustomerQueryModal, setShowCustomerQueryModal] = useState(false);
const [customerQueryMessage, setCustomerQueryMessage] = useState("");
const [customerQueryPhone, setCustomerQueryPhone] = useState("");
const [customerQuerySubmitting, setCustomerQuerySubmitting] = useState(false);
const [customerQueryError, setCustomerQueryError] = useState("");
const [customerQuerySuccess, setCustomerQuerySuccess] = useState("");
const [customerQueryRef, setCustomerQueryRef] = useState("");



// ------------------------------
// Clara
// ------------------------------
const [showClara, setShowClara] = useState(false);
const [showClaraInfo, setShowClaraInfo] = useState(false);
const [showClaraIntro, setShowClaraIntro] = useState(true);


const freemiumProofs = [
  "Six By Nico — one visit, 200k+ views",
  "Le Grand Bus, Mayfair — 100+ booking requests",
  "Plied and Prejudice, West End — 1m views",
  'Del74 — "Can’t recommend it enough"',
];

  // Boot (full-page) loader
  const [boot, setBoot] = useState(true);
  const [bootMsg, setBootMsg] = useState("Loading your dashboard…");
  const funMsgs = [
    "Fetching your collabs…",
    "Matching you to creators…",
    "Counting your bookings…",
    "Polishing the tiles…",
    "Warming up the tiles…",
  ];
  useEffect(() => {
    if (!boot) return;
    let i = 0;
    setBootMsg(funMsgs[0]);
    const id = setInterval(() => {
      i = (i + 1) % funMsgs.length;
      setBootMsg(funMsgs[i]);
    }, 1200);
    return () => clearInterval(id);
  }, [boot]);

  const getCoverImage = (logoCsv) => {
    if (!logoCsv || !logoCsv.trim()) {
      return "https://collabbayadmin.com/NoListingImage.jpg";
    }
    const first = logoCsv
      .split(",")
      .map((s) => s.trim())
      .filter(Boolean)[0];
    if (!first) return "https://collabbayadmin.com/NoListingImage.jpg";
    const url = first.startsWith("http") ? first : IMAGE_BASE + first;
    // ✅ Avoid template literal to fix syntax error
    return url + "?t=" + Date.now();
  };

  const ts = (v, fb = Number.POSITIVE_INFINITY) => {
    const t = v ? Date.parse(v) : NaN;
    return Number.isNaN(t) ? fb : t;
  };
  const creditTS = (c) => ts(c?.CreditAvailableStart);
  const plainDateTS = (c) => ts(c?.Date);

  const displayCollabs = useMemo(() => {
    const visible = Array.isArray(collabs)
      ? collabs.filter((c) => c.BrandNotInterested !== "Y")
      : [];
    const byCreditAsc = [...visible].sort((a, b) => creditTS(a) - creditTS(b));
    if (isAuthenticated || byCreditAsc.length === 0) return byCreditAsc;

    // not auth: pick single free row (oldest by Date)
    const trialTop = [...visible].sort(
      (a, b) => plainDateTS(a) - plainDateTS(b)
    )[0];
    if (!trialTop) return byCreditAsc;
    const rest = byCreditAsc.filter((x) => x.CollabID !== trialTop.CollabID);
    return [trialTop, ...rest];
  }, [collabs, isAuthenticated]);

  const trialFreeCollabID = useMemo(() => {
    if (isAuthenticated) return null;
    if (!Array.isArray(collabs) || collabs.length === 0) return null;

    // same rule as displayCollabs: oldest by Date
    const visible = collabs.filter((c) => c.BrandNotInterested !== "Y");
    const trialTop = [...visible].sort(
      (a, b) => plainDateTS(a) - plainDateTS(b)
    )[0];
    return trialTop?.CollabID || null;
  }, [collabs, isAuthenticated]);

  const [searchName, setSearchName] = useState("");
  const [statusFilter, setStatusFilter] = useState("All"); // All | Upcoming | Expired | Redeemed | Pending | Cancelled | Invited
  const [sortMode, setSortMode] = useState("Soonest"); // Soonest | Latest | Created-Newest | Created-Oldest

  const filteredCollabs = useMemo(() => {
    let items = displayCollabs;

    if (searchName.trim()) {
      const q = searchName.trim().toLowerCase();
      items = items.filter((c) =>
        (c?.Promoter || "").toLowerCase().includes(q)
      );
    }

    if (statusFilter !== "All") {
      items = items.filter((c) => getStatus(c) === statusFilter);
    }

 
    const copy = [...items];

copy.sort((a, b) => {
  const aUnseen =
    String(a?.HasBrandSeenOffer || "").trim().toUpperCase() !== "Y";

  const bUnseen =
    String(b?.HasBrandSeenOffer || "").trim().toUpperCase() !== "Y";

  // Unseen requests always come first
  if (aUnseen !== bUnseen) {
    return aUnseen ? -1 : 1;
  }

  // Within each group, keep the existing date sorting
  if (sortMode === "Soonest") {
    return creditTS(a) - creditTS(b);
  }

  if (sortMode === "Latest") {
    return creditTS(b) - creditTS(a);
  }

  if (sortMode === "Created-Newest") {
    return plainDateTS(b) - plainDateTS(a);
  }

  if (sortMode === "Created-Oldest") {
    return plainDateTS(a) - plainDateTS(b);
  }

  return 0;
});

return copy;
  }, [displayCollabs, searchName, statusFilter, sortMode]);

  // ------------------------------
  // Utilities: inject global styles
  // ------------------------------
  const injectOnce = useRef(false);
  useEffect(() => {
    if (injectOnce.current) return;
    injectOnce.current = true;

    // Google font + CSS variables
    const font = document.createElement("link");
    font.rel = "preconnect";
    font.href = "https://fonts.gstatic.com";
    document.head.appendChild(font);

    const font2 = document.createElement("link");
    font2.href =
      "https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700;800&display=swap";
    font2.rel = "stylesheet";
    document.head.appendChild(font2);

    const style = document.createElement("style");
    style.innerHTML = `
      :root{
        --bg: #f3f3f3;
        --bg2:#ffffff;
        --card: rgba(255,255,255,0.88);
        --glass: rgba(255,255,255,0.94);
        --muted: #6b7280;
        --brand: #FDF05D;
        --text: #f9fafb;          /* used mainly in sidebar */
        --text-strong:#ffffff;
        --ok:#4CD964;
        --warn:#f2c94c;
        --bad:#eb5757;
        --accent:#111214;
      }

      html, body, #root, #app {
        min-height: 100%;
        background-color: var(--bg);
        margin:0;
        padding:0;
      }

      * { box-sizing: border-box; }

      body{
        font-family: Montserrat,system-ui,-apple-system,Segoe UI,Roboto,Helvetica,Arial,sans-serif;
        color-scheme: light;
      }

      video, img { background-color: transparent; }

      .wrap{
        display:flex;
        min-height:100vh;
        width:100%;
        max-width:none;
        margin:0;
        overflow-x:hidden;
        background:#f3f3f3;
      }

      .main{
        flex:1;
        display:flex;
        flex-direction:column;
        gap:20px;
        padding:24px 28px;
        background:#f3f3f3;
        margin-left:230px; /* offset for fixed sidebar */
        color:#111827;     /* main content text dark */
      }

      *{box-sizing:border-box}

      .sidebar{
        width:230px;
        height:100vh;
        position:fixed;
        top:0;
        left:0;
        padding:28px 22px 20px 22px;
        font-family:Montserrat,system-ui,-apple-system,Segoe UI, Roboto, Helvetica, Arial, sans-serif;
        background: radial-gradient(600px 420px at 0% 0%, rgba(253,240,93,0.18), transparent 60%), 
                    linear-gradient(180deg,#050509,#050505,#000000);
        border-right:1px solid rgba(255,255,255,0.08);
        backdrop-filter: blur(18px);
        display:flex;
        flex-direction:column;
        gap:14px;
        overflow-y:auto;
        z-index:50;
        color:var(--text);
      }
      .logoRow{display:flex;align-items:center;gap:10px;margin-bottom:12px}
      .logo{
        width:36px;height:36px;border-radius:18px;background:#000;display:inline-flex;align-items:center;justify-content:center;
      }
      .logo img{width:24px;height:24px;object-fit:contain;}
      .appName{
        font-family: Montserrat,system-ui,-apple-system,Segoe UI,Roboto,Helvetica,Arial,sans-serif;
        font-weight:800; letter-spacing:.2px; color:#f5f5f5;
      }
      .modeTag{
        text-transform: uppercase;
        letter-spacing: .18em;
        font-weight: 500;
        font-size: 10px;
        color: #b3b3b3;
        opacity: .95;
        margin-top: 2px;
      }
      .nav{
        margin-top:4px;
        display:flex;
        flex-direction:column;
        gap:6px;
      }
      .nav button{
        appearance:none;border:none;background:transparent;color:#f5f5f5;
        text-align:left;padding:9px 12px;border-radius:10px;display:flex;gap:10px;align-items:center;
        transition:.2s ease;cursor:pointer
      }
      .nav button:hover{background:rgba(255,255,255,0.06)}
      .nav .cta{
        background:var(--brand);color:#000;font-weight:700;justify-content:center;margin-top:8px;border-radius:999px;
      }
      .nav .cta:hover{filter:brightness(0.95)}
      .nav .pill{
        font-size:12px;background:#000;color:#fff;padding:2px 8px;border-radius:999px;margin-left:auto
      }

      .upgradeBtn{
        margin-top:10px;
        width:100%;
        border-radius:999px;
        padding:9px 12px;
        border:none;
        background:linear-gradient(135deg,#FDF05D,#ffe983);
        color:#000;
        font-weight:800;
        font-size:13px;
        display:flex;
        align-items:center;
        justify-content:flex-start;
        cursor:pointer;
      }
      .upgradeBtnTitleOnly{
        font-weight:800;
        font-size:13px;
      }

      .sideActions{
        margin-top:10px;
        display:flex;
        flex-direction:column;
        gap:8px;
      }

      .sideActionCard{
        width:100%;
        border-radius:14px;
        border:1px solid rgba(255,255,255,0.08);
        background:rgba(255,255,255,0.03);
        padding:8px 10px;
        display:flex;
        flex-direction:column;
        gap:4px;
        cursor:pointer;
        transition:background .15s ease, transform .15s ease, border-color .15s ease;
        color:#f5f5f5;
      }
      .sideActionCard:hover{
        background:rgba(255,255,255,0.06);
        border-color:rgba(255,255,255,0.14);
        transform:translateY(-1px);
      }
      .sideActionTitle{
        font-size:12px;
        font-weight:700;
        letter-spacing:.02em;
      }
      .sideActionSubtitle{
        font-size:11px;
        color:#b3b3b3;
      }

      .mapActionRow{
        display:flex;
        align-items:center;
        gap:8px;
      }

      .newBadge{
        display:inline-flex;
        align-items:center;
        justify-content:center;
        margin-left:6px;
        font-size:9px;
        padding:2px 6px;
        border-radius:999px;
        background:#FDF05D;
        color:#000;
        font-weight:800;
        text-transform:uppercase;
        letter-spacing:.06em;
      }

      .grid, .col, .list, .row, .nameRow, .offer, .offerBody { min-width: 0; }

      .nameRow { gap:10px; min-width:0; }
      .nameRow .promoter {
        flex:1;
        min-width:0;
        overflow:hidden;
        text-overflow:ellipsis;
        white-space:nowrap;
      }

      .row, .chip, .offerBody, .miniSub, .offerTitle {
        overflow-wrap:anywhere;
        word-break:break-word;
      }

      img, video { max-width:100%; height:auto; }

      .top{
        display:flex;align-items:center;justify-content:space-between;gap:16px;
      }
      .hello{
        display:flex;align-items:center;gap:12px;
        padding:12px 14px;border-radius:20px;

      }
      .hello img{width:32px;height:32px;border-radius:50%;object-fit:cover;background:#e5e7eb}
      .hello .hi{font-weight:700; font-size: 32px;color:#111827;}
      .badge{
        display:inline-flex;align-items:center;gap:6px;
        background:rgba(15,23,42,0.06);
        padding:6px 10px;border-radius:999px;font-size:12px;
        color:#111827;
      }
        
.hiAvatarBtn{
  width:48px;
  height:48px;
  border-radius:50%;
  display:flex;
  align-items:center;
  justify-content:center;
  flex:0 0 auto;
  cursor:pointer;
  padding:0;
  border:none;
  background:transparent;
  overflow:hidden;
}

.hiAvatarBtn--empty{
  background:#000000;
  border:1px solid rgba(255,255,255,0.16);
}
.hiAvatarBtn--empty:hover{
  filter:brightness(1.08);
}

.hiAvatarBtn svg{ display:block; }

.hiAvatarBtn img{
  width:100%;
  height:100%;
  object-fit:cover;
  border-radius:50%;
  display:block;
}



      .recent{
        display:flex;align-items:center;gap:10px;
        background:rgba(255,255,255,0.9);
        border:1px solid rgba(15,23,42,0.06);
        font-size: 10px;
        padding:10px 12px;border-radius:20px;
        box-shadow:0 18px 40px rgba(15,23,42,0.06);
      }
      .avatars{display:flex;align-items:center}
      .av{width:31px;height:31px;border-radius:50%;border:2px solid #f3f3f3;margin-left:-8px;overflow:hidden;background:#e5e7eb}
      .av img{width:100%;height:100%;object-fit:cover}
      .greenDot{width:10px;height:10px;border-radius:50%;background:var(--ok);position:relative;left:-6px;top:-8px;border:2px solid #f3f3f3}
      .plus{font-size:12px;color:#6b7280;padding-left:6px}
      
      .grid{
        display:grid;
        grid-template-columns: 1.35fr 1fr;
        gap:18px;
        position:relative;
        margin-top:12px;
      }
      .col{display:flex;flex-direction:column;gap:18px}

      .card{
        background:var(--card);
        border:1px solid rgba(15,23,42,0.08);
        border-radius:18px;
        padding:16px;
        backdrop-filter: blur(16px);
        box-shadow:0 18px 45px rgba(15,23,42,0.10);
      }
      .cardHeader{display:flex;align-items:center;justify-content:space-between;margin-bottom:8px}
      .cardTitle{font-weight:800;letter-spacing:.2px;color:#111827;}
      .linkBtn{
        display:inline-flex;align-items:center;gap:8px;border-radius:20px;
        padding:8px 12px;
        background:#fdf05d;
        cursor:pointer;
        font-weight:600;
        color:#111827;
        border:1px solid rgba(15,23,42,0.08);
      }
      .linkBtn:hover{background:rgba(15,23,42,0.07)}

      .upgradeStrip{
        display:flex;
        align-items:center;
        justify-content:space-between;
        gap:12px;
        border:1px solid rgba(253,240,93,0.4);
        background:linear-gradient(120deg,rgba(253,240,93,0.16),rgba(253,240,93,0.04));
      }
      .upgradeStripText{
        display:flex;
        flex-direction:column;
        gap:4px;
      }
      .upgradeStripTitle{
        font-weight:800;
        font-size:14px;
        color:#111827;
      }
      .upgradeStripSub{
        font-size:12px;
        color:#4b5563;
      }
      .upgradeStripBtn{
        border:none;
        border-radius:999px;
        padding:8px 12px;
        background:#FDF05D;
        color:#000;
        font-weight:800;
        font-size:13px;
        display:inline-flex;
        align-items:center;
        gap:6px;
        cursor:pointer;
        white-space:nowrap;
      }

      .pillBox{display:inline-flex;align-items:center;gap:10px;background:#0f1115;border:1px solid #21232a;border-radius:999px;padding:6px 10px}
      .countPill{font-size: 21px; background:#000;border-radius:999px;padding:2px 8px;font-weight:800;color:#FDF05D;}

      .hScroll{display:flex;overflow:auto;gap:12px;padding-bottom:6px}
      .miniCard{
        min-width:260px;height:72px;
        background:rgba(255,255,255,0.9);
        border:1px solid rgba(15,23,42,0.08);
        border-radius:14px;padding:10px;display:flex;gap:10px;align-items:center;
        box-shadow:0 14px 30px rgba(15,23,42,0.08);
      }
      .circle{width:46px;height:46px;border-radius:50%;overflow:hidden;background:#e5e7eb;flex:0 0 auto}
      .circle img{width:100%;height:100%;object-fit:cover}
      .miniTitle{font-weight:700;color:#111827;}
      .miniSub{font-size:14px;color:#6b7280}

      .venueCard{
        position:relative;
        border-radius:14px;overflow:hidden;
        background:#000;display:flex;align-items:flex-end;justify-content:center
      }
      .venueOverlay{position:absolute;inset:0;background:linear-gradient(180deg,rgba(0,0,0,.2),rgba(0,0,0,.75))}
      .venueInner{position:relative;z-index:2;display:flex;flex-direction:column;align-items:center;gap:4px;padding-bottom:10px}
      .venueLabel{font-size:12px;color:#ddd}
      .venueValue{font-size:44px;font-weight:800;color:#fff;line-height:1}

      /* Collab list */
      .list{display:flex;flex-direction:column;gap:10px;margin-top:6px}
      .row{
        position:relative;
        background:rgba(255,255,255,0.96);
        border:1px solid rgba(15,23,42,0.08);
        border-radius:14px;
        padding:12px;
        display:flex;
        flex-direction:column;
        gap:8px;
        cursor:pointer;
        transition:.2s ease;
        box-shadow:0 12px 30px rgba(15,23,42,0.10);
      }
      .row:hover{transform:translateY(-1px)}
      .unseenRequestBadge{
  position:absolute;
  top:-7px;
  right:-7px;
  width:22px;
  height:22px;
  border-radius:999px;
  background:#ef4444;
  color:#ffffff;
  border:2px solid #ffffff;
  display:flex;
  align-items:center;
  justify-content:center;
  font-size:11px;
  font-weight:800;
  line-height:1;
  z-index:5;
  box-shadow:0 4px 10px rgba(0,0,0,0.18);
}
      .row.free{box-shadow:0 0 0 2px var(--ok) inset}
      .row.proposal{
  box-shadow:0 0 0 2px #2563eb inset;
  background:linear-gradient(180deg, rgba(239,246,255,0.98), rgba(255,255,255,0.98));
}


.helloTitleRow{
  display:flex;
  align-items:center;
  gap:14px;
  flex-wrap:wrap;
}

.accountPlanBadge{
  appearance:none;
  min-height:50px;
  padding:7px 14px 7px 15px;

  display:inline-flex;
  align-items:center;
  gap:14px;

  border:1px solid rgba(17,24,39,0.13);
  border-radius:15px;

  font-family:Montserrat,system-ui,-apple-system,Segoe UI,Roboto,Helvetica,Arial,sans-serif;

  cursor:pointer;

  transition:
    transform .16s ease,
    box-shadow .16s ease,
    border-color .16s ease;
}

.accountPlanBadge:hover{
  transform:translateY(-2px);
  box-shadow:
    0 14px 30px rgba(15,23,42,0.13),
    inset 0 1px 0 rgba(255,255,255,0.85);
}

.accountPlanCopy{
  display:flex;
  flex-direction:column;
  align-items:flex-start;
  gap:1px;
  line-height:1.15;
}

.accountPlanLabel{
  font-size:9px;
  font-weight:600;
  letter-spacing:.04em;
  opacity:.58;
}

.accountPlanName{
  font-size:11px;
  font-weight:750;
  letter-spacing:.025em;
  white-space:nowrap;
  color: #a5c29b: 
}


.accountPlanBadge{
  appearance:none;
  min-height:50px;
  padding:8px 16px;

  display:inline-flex;
  align-items:center;

  border:1.5px solid #c9cbbf;
  border-radius:16px;

  background: #CCDECC;
  color: #a5c29b;

  font-family:Montserrat,system-ui,-apple-system,Segoe UI,Roboto,Helvetica,Arial,sans-serif;

  cursor:pointer;
  font-size:10px;

 

  transition:
    transform .16s ease,
    background .16s ease,
    border-color .16s ease,
    box-shadow .16s ease;
}

.accountPlanBadge:hover{
  transform:translateY(-1px);
  background:#ebece4;
  border-color:#aeb1a4;
  box-shadow:0 10px 22px rgba(15,23,42,0.08);
}

.accountPlanCopy{
  display:flex;
  flex-direction:column;
  align-items:flex-start;
  gap:2px;
  line-height:1.1;
}

.accountPlanLabel{
  font-size:9px;
  font-weight:600;
  color:#74776d;
  letter-spacing:.025em;
}

.accountPlanName{
  font-size:14px;
  font-weight:800;
  color:#111827;
  letter-spacing:.015em;
  white-space:nowrap;
}
.proposalBadge{
  position:absolute;
  top:-8px;
  left:14px;
  background:#2563eb;
  color:#fff;
  font-weight:800;
  border-radius:999px;
  padding:4px 8px;
  font-size:12px;
  box-shadow:0 8px 18px rgba(37,99,235,0.22);
}

.proposalInfo{
  background:#eff6ff;
  border:1px solid #bfdbfe;
  color:#1e3a8a;
  border-radius:14px;
  padding:10px 12px;
  font-size:13px;
  font-weight:700;
  line-height:1.45;
  margin:8px 0 12px 0;
}
      .rowTop{display:flex;align-items:center;justify-content:space-between}
      .status{display:inline-flex;align-items:center;gap:6px;border-radius:999px;padding:4px 8px;font-size:12px;border:1px solid rgba(255,255,255,.1);color:#f9fafb;}
      .status.expired{background:#5f6368}
      .status.redeemed{background:#0b5d2c}
      .status.upcoming{background:#285a2b}
      .status.pending{background:#695c14}
      .status.cancelled{background:#5a1b1b}
      .status.invited{background:#5a5314}
      .nameRow{display:flex;align-items:center;gap:10px}
      .avatar{width:40px;height:40px;border-radius:50%;overflow:hidden;background:#e5e7eb;flex:0 0 auto}
      .avatar img{width:100%;height:100%;object-fit:cover}
      .promoter{font-weight:700;color:#111827;}

      .blurredName{
        filter: blur(4px);
        opacity:.85;
      }
      .blurredAvatar img{
        filter: blur(4px);
        opacity:.9;
      }

      /* Chevron on right of each row */
      .rowChevron{
        position:absolute;
        right:12px;
        top:50%;
        transform:translateY(-50%);
        display:flex;
        align-items:center;
        justify-content:center;
        pointer-events:none;
        opacity:0.7;
      }
      .row:hover .rowChevron{
        opacity:1;
        transform:translate(2px,-50%);
      }

      /* group chips on one line and allow wrapping */
      .chipRow{ display:flex; flex-wrap:wrap; gap:8px }

      .chip{
        display:inline-flex; align-items:center;
        padding:6px 10px; border-radius:12px;
        background:#f3f4f6; border:1px solid #e5e7eb;
        font-size:13px; font-weight:600;
        align-self:flex-start;
        width:fit-content; max-width:100%;
        white-space:normal;
        color:#111827;
      }

      .offerChip{
        background:rgba(253,240,93,0.16);
        border-color:rgba(253,240,93,.55);
      }
      .clientChip{
        background:rgba(249,250,251,1);
        border-color:#d1d5db;
      }

      .chip .label{ font-weight:800; margin-right:6px; opacity:.9 }

      /* Offers */
      .offer{
        background:rgba(255,255,255,0.96);
        border:1px solid rgba(15,23,42,0.08);
        border-radius:14px;
        overflow:hidden;
        box-shadow:0 16px 35px rgba(15,23,42,0.10);
      }
      .offerImg{height:110px;background:#111;position:relative}
      .viewsBadge{
  position:absolute;
  top:10px;
  left:10px;
  display:inline-flex;
  align-items:center;
  gap:6px;
  padding:6px 10px;
  border-radius:999px;
  background:rgba(0,0,0,0.55);
  border:1px solid rgba(255,255,255,0.18);
  color:#fff;
  font-weight: 700;
  font-size:14px;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
}
.viewsBadge svg{display:block}

      .offerImg img{width:100%;height:100%;object-fit:cover}
      .editFab{position:absolute;top:8px;right:8px;background:rgba(0,0,0,0.5);border:1px solid rgba(255,255,255,0.16);border-radius:999px;padding:6px}
      .offerBody{padding:12px}
      .offerTitle{font-weight:700;color:#111827;}
      .offerSub{font-size:12px;color:#4b5563}
      .live{display:inline-flex;align-items:center;gap:6px;border-radius:999px;padding:4px 8px;border:1px solid #2e6130;background:#17361a;color:#9cf0a2;font-weight:700;font-size:12px}
      .paused{display:inline-flex;align-items:center;gap:6px;border-radius:999px;padding:4px 8px;border:1px solid #555;background:#222;color:#eee;font-weight:700;font-size:12px}

      /* RAG */
      .rag{display:flex;flex-direction:column;gap:10px}
      .ragItem{border-radius:12px;border:2px solid transparent;padding:12px;background:#f9fafb}
      .ragItem.yellow{border-color:var(--warn)}
      .ragItem.red{border-color:var(--bad)}
      .ragTitle{font-weight:800;color:#111827;}
      .ragSub{color:#4b5563}

      /* Modals */
      .modalOverlay{position:fixed;inset:0;background:rgba(0,0,0,.55);display:flex;align-items:center;justify-content:center;z-index:60}
      .modal{width:min(560px,92vw);background:#ffffff;border:1px solid rgba(15,23,42,0.12);border-radius:16px;padding:18px;box-shadow:0 25px 80px rgba(15,23,42,0.35);}
      .modalHeader{display:flex;align-items:center;justify-content:space-between;margin-bottom:6px}
      .x{cursor:pointer;border:none;background:transparent;color:#111827;font-size:20px}
      .ctaBtn{background:#fdf05d;border:none;border-radius:12px;padding:10px 14px;font-weight:800;cursor:pointer;color:#000;}
      .ghostBtn{background:transparent;border:1px solid rgba(15,23,42,.16);border-radius:12px;padding:10px 14px;color:#111827;cursor:pointer}
      .danger{background:#2a0f12;border:1px solid #6d1f26;color:#fef2f2;}
      .center{display:flex;align-items:center;justify-content:center}
      .muted{color:var(--muted)}
      .brand{color:var(--brand)}
      .hr{height:1px;background:rgba(15,23,42,.08);margin:10px 0}
      .grid2{display:grid;grid-template-columns:1fr 1fr;gap:12px}

      @media (max-width: 1050px){
        .wrap{max-width:100%}
        .grid{grid-template-columns:1fr}
      }

      .grid::before{
        content:"";
        position:absolute;
        inset:0;
        background:
          linear-gradient(180deg, rgba(243,244,246,0.96) 0px, rgba(243,244,246,0.92) 120px, rgba(243,244,246,0) 280px),
          radial-gradient(650px 420px at 15% 8%, rgba(253,240,93,0.23), transparent 60%),
          radial-gradient(520px 360px at 82% 22%, rgba(253,240,93,0.20), transparent 65%),
          radial-gradient(740px 480px at 58% 78%, rgba(253,240,93,0.16), transparent 70%);
        background-size: cover;
        background-repeat: no-repeat;
        z-index: 0;
        border-radius: 16px;
      }

      .grid > *{
        position: relative;
        z-index: 1;
      }


/* =========================================================
   CLARA™
   ========================================================= */

.claraLaunchLayer{
  position:fixed;
  inset:0;

  z-index:2147483000;

  pointer-events:none;
}


/* SIDEBAR */

.claraNavButton{
  position:relative;
}

.claraNavNew{
  margin-left:auto;

  padding:3px 7px;

  border-radius:999px;

  background:#FDF05D;
  color:#000;

  font-size:8px;
  font-weight:800;
  line-height:1;

  letter-spacing:.08em;
  text-transform:uppercase;
}


/* =========================================================
   INTRO CARD
   ========================================================= */

.claraIntroCard{
  position:absolute;

  right:26px;
  bottom:112px;

  width:340px;

  padding:21px;

  pointer-events:auto;

  border-radius:25px;

  border:1px solid rgba(253,240,93,.52);

  background:
    radial-gradient(
      480px 180px at 100% 0%,
      rgba(253,240,93,.17),
      transparent 52%
    ),
    linear-gradient(
      145deg,
      rgba(255,255,255,.96),
      rgba(255,255,255,.82)
    );

  -webkit-backdrop-filter:blur(28px);
  backdrop-filter:blur(28px);

  box-shadow:
    0 30px 90px rgba(15,23,42,.22),
    0 0 0 1px rgba(253,240,93,.10),
    0 0 42px rgba(253,240,93,.11),
    inset 0 1px 0 rgba(255,255,255,.98);

  color:#111827;

  animation:
    claraIntroIn .55s cubic-bezier(.2,.85,.2,1);
}

@keyframes claraIntroIn{

  0%{
    opacity:0;
    transform:
      translateY(20px)
      scale(.94);
  }

  70%{
    opacity:1;
    transform:
      translateY(-2px)
      scale(1.015);
  }

  100%{
    opacity:1;
    transform:
      translateY(0)
      scale(1);
  }
}


.claraIntroClose{
  position:absolute;

  top:12px;
  right:12px;

  width:29px;
  height:29px;

  border:none;
  border-radius:999px;

  display:flex;
  align-items:center;
  justify-content:center;

  background:rgba(17,24,39,.06);
  color:#111827;

  font-size:18px;
  line-height:1;

  cursor:pointer;
}


.claraIntroClose:hover{
  background:rgba(17,24,39,.10);
}


.claraIntroTop{
  display:flex;
  align-items:center;

  gap:7px;

  margin-bottom:16px;
}


.claraNewBadge{
  display:inline-flex;
  align-items:center;
  justify-content:center;

  padding:5px 9px;

  border-radius:999px;

  background:rgba(253,240,93,.88);

  border:1px solid rgba(203,187,0,.14);

  color:#111827;

  font-size:9px;
  line-height:1;
  font-weight:900;

  letter-spacing:.10em;
}


.claraInfoMini{
  width:22px;
  height:22px;

  padding:0;

  display:flex;
  align-items:center;
  justify-content:center;

  border-radius:999px;

  border:1px solid rgba(17,24,39,.12);

  background:rgba(255,255,255,.72);

  color:#111827;

  font-size:11px;
  font-weight:800;

  cursor:pointer;
}


.claraIntroEyebrow{
  margin-bottom:7px;

  color:#777b84;

  font-size:9px;
  font-weight:700;

  letter-spacing:.13em;
}


.claraIntroTitle{
  color:#111827;

  font-size:21px;
  font-weight:500;

  line-height:1.24;

  letter-spacing:-.03em;
}


.claraIntroTitle strong{
  font-weight:800;
}


.claraNameHighlight{
  display:inline-block;

  margin-top:3px;

  font-size:29px;
  line-height:1;

  font-weight:800;

  letter-spacing:-.045em;

  background:
    linear-gradient(
      90deg,
      #111827 0%,
      #111827 32%,
      #b5a600 75%,
      #d5c400 100%
    );

  -webkit-background-clip:text;
  background-clip:text;

  -webkit-text-fill-color:transparent;
}


.claraIntroText{
  margin-top:11px;

  max-width:285px;

  color:#646b76;

  font-size:12px;
  font-weight:500;

  line-height:1.55;
}


.claraIntroCTA{
  width:100%;

  margin-top:18px;

  padding:13px 16px;

  border:none;

  border-radius:999px;

  background:
    linear-gradient(
      135deg,
      #111214,
      #050505
    );

  color:#fff;

  font-family:
    Montserrat,
    system-ui,
    -apple-system,
    sans-serif;

  font-size:12px;
  font-weight:700;

  display:flex;
  align-items:center;
  justify-content:space-between;

  cursor:pointer;

  box-shadow:
    0 12px 28px rgba(17,24,39,.16);

  transition:
    transform .17s ease,
    box-shadow .17s ease;
}


.claraIntroCTA:hover{
  transform:translateY(-1px);

  box-shadow:
    0 16px 34px rgba(17,24,39,.21);
}


.claraIntroArrow{
  color:#FDF05D;

  font-size:17px;
}


/* =========================================================
   FLOATING LAUNCHER
   ========================================================= */

.claraFloat{
  position:absolute;

  right:26px;
  bottom:26px;

  width:72px;
  height:72px;

  padding:0;

  pointer-events:auto;

  border-radius:999px;

  border:1px solid rgba(253,240,93,.60);

  background:
    radial-gradient(
      circle at 31% 23%,
      rgba(253,240,93,.48),
      transparent 37%
    ),
    linear-gradient(
      145deg,
      #171717,
      #020202
    );

  color:#FDF05D;

  display:flex;
  align-items:center;
  justify-content:center;

  cursor:pointer;

  -webkit-backdrop-filter:blur(20px);
  backdrop-filter:blur(20px);

  box-shadow:
    0 22px 60px rgba(0,0,0,.35),
    0 0 0 5px rgba(253,240,93,.08),
    0 0 34px rgba(253,240,93,.24),
    inset 0 1px 0 rgba(255,255,255,.18);

  animation:
    claraFloatEntrance .65s cubic-bezier(.2,.9,.2,1);

  transition:
    transform .18s ease,
    box-shadow .18s ease;
}


@keyframes claraFloatEntrance{

  0%{
    opacity:0;

    transform:
      translateY(16px)
      scale(.55);
  }

  70%{
    opacity:1;

    transform:
      translateY(-2px)
      scale(1.08);
  }

  100%{
    opacity:1;

    transform:
      translateY(0)
      scale(1);
  }
}


.claraFloat:hover{
  transform:
    translateY(-5px)
    scale(1.055);

  box-shadow:
    0 28px 72px rgba(0,0,0,.38),
    0 0 0 8px rgba(253,240,93,.10),
    0 0 46px rgba(253,240,93,.35);
}


.claraFloatInner{
  position:relative;

  z-index:3;

  display:flex;
  align-items:center;
  justify-content:center;
}


.claraFloatPulse{
  position:absolute;

  inset:-8px;

  border-radius:999px;

  border:
    1.5px solid rgba(253,240,93,.48);

  box-shadow:
    0 0 18px rgba(253,240,93,.16);

  animation:
    claraPulse 2.3s ease-out infinite;
}


@keyframes claraPulse{

  0%{
    transform:scale(.85);
    opacity:.78;
  }

  68%{
    transform:scale(1.30);
    opacity:0;
  }

  100%{
    transform:scale(1.30);
    opacity:0;
  }
}


.claraOnlineDotFloat{
  position:absolute;

  right:4px;
  bottom:5px;

  width:13px;
  height:13px;

  border-radius:999px;

  background:#4CD964;

  border:3px solid #080808;

  z-index:4;
}


/* Persistent NEW · Clara label */

.claraFloatLabel{
  position:absolute;

  right:59px;
  top:50%;

  transform:translateY(-50%);

  height:40px;

  padding:
    0 17px
    0 10px;

  display:flex;
  align-items:center;

  gap:7px;

  white-space:nowrap;

  border-radius:999px;

  border:
    1px solid rgba(255,255,255,.91);

  background:
    linear-gradient(
      135deg,
      rgba(255,255,255,.90),
      rgba(255,255,255,.75)
    );

  -webkit-backdrop-filter:blur(22px);
  backdrop-filter:blur(22px);

  box-shadow:
    0 14px 38px rgba(15,23,42,.15),
    0 0 25px rgba(253,240,93,.10),
    inset 0 1px 0 rgba(255,255,255,.98);

  color:#111827;

  pointer-events:none;

  z-index:1;
}


.claraFloatLabelNew{
  padding:4px 6px;

  border-radius:999px;

  background:
    rgba(253,240,93,.82);

  color:#111827;

  font-size:7px;
  line-height:1;

  font-weight:900;

  letter-spacing:.08em;
}


.claraFloatLabelName{
  font-size:11px;
  font-weight:800;

  letter-spacing:-.01em;
}


/* =========================================================
   DRAWER
   ========================================================= */

.claraOverlay{
  position:fixed;

  inset:0;

  z-index:2147483100;

  display:flex;
  justify-content:flex-end;

  background:
    rgba(3,7,18,.26);

  -webkit-backdrop-filter:blur(4px);
  backdrop-filter:blur(4px);
}


.claraDrawer{
  width:min(620px,94vw);

  height:100vh;
  height:100dvh;

  max-height:100dvh;

  display:flex;
  flex-direction:column;

  background:
    rgba(249,249,247,.99);

  border-left:
    1px solid rgba(255,255,255,.76);

  box-shadow:
    -28px 0 90px rgba(0,0,0,.22);

  overflow:hidden;

  animation:
    claraDrawerIn .32s cubic-bezier(.2,.8,.2,1);
}


@keyframes claraDrawerIn{

  from{
    transform:translateX(100%);
  }

  to{
    transform:translateX(0);
  }
}


.claraDrawerHeader{
  flex:0 0 72px;

  min-height:72px;

  padding:
    0 18px;

  display:flex;
  align-items:center;
  justify-content:space-between;

  background:
    rgba(255,255,255,.86);

  border-bottom:
    1px solid rgba(17,24,39,.07);

  -webkit-backdrop-filter:blur(20px);
  backdrop-filter:blur(20px);
}


.claraDrawerIdentity{
  display:flex;
  align-items:center;

  gap:11px;
}


.claraDrawerLogo{
  width:40px;
  height:40px;

  flex:0 0 auto;

  border-radius:14px;

  display:flex;
  align-items:center;
  justify-content:center;

  background:#111214;

  color:#FDF05D;

  box-shadow:
    0 9px 25px rgba(17,24,39,.16);
}


.claraDrawerTitleRow{
  display:flex;
  align-items:center;

  gap:7px;
}


.claraDrawerTitle{
  color:#111827;

  font-size:15px;
  font-weight:800;
}


.claraLiveDot{
  width:7px;
  height:7px;

  border-radius:999px;

  background:#4CD964;
}


.claraDrawerSubtitle{
  margin-top:2px;

  color:#747983;

  font-size:10px;
  font-weight:550;
}


.claraDrawerControls{
  display:flex;
  align-items:center;

  gap:7px;
}


.claraDrawerControl{
  width:35px;
  height:35px;

  padding:0;

  border-radius:999px;

  border:
    1px solid rgba(17,24,39,.09);

  background:#f4f4f3;

  color:#111827;

  font-size:17px;
  font-weight:700;

  display:flex;
  align-items:center;
  justify-content:center;

  cursor:pointer;
}


.claraDrawerControl:hover{
  background:#eaeae8;
}


.claraIframeWrap{
  flex:1;

  min-height:0;

  width:100%;

  overflow:hidden;

  background:#fff;
}


.claraIframe{
  display:block;

  width:100%;
  height:100%;

  min-height:0;

  border:0;

  background:#fff;
}


/* =========================================================
   INFO POPUP
   ========================================================= */

.claraInfoOverlay{
  position:fixed;

  inset:0;

  z-index:2147483200;

  display:flex;
  align-items:center;
  justify-content:center;

  padding:20px;

  background:
    rgba(3,7,18,.40);

  -webkit-backdrop-filter:blur(8px);
  backdrop-filter:blur(8px);
}


.claraInfoModal{
  position:relative;

  width:min(480px,94vw);

  max-height:
    calc(100dvh - 32px);

  overflow:auto;

  padding:27px;

  border-radius:28px;

  border:
    1px solid rgba(255,255,255,.88);

  background:
    radial-gradient(
      500px 190px at 100% 0%,
      rgba(253,240,93,.14),
      transparent 55%
    ),
    linear-gradient(
      145deg,
      rgba(255,255,255,.99),
      rgba(250,250,248,.96)
    );

  box-shadow:
    0 35px 110px rgba(0,0,0,.32);

  color:#111827;
}


.claraInfoClose{
  position:absolute;

  top:14px;
  right:14px;

  width:32px;
  height:32px;

  padding:0;

  border:none;

  border-radius:999px;

  background:#f3f4f6;

  color:#111827;

  font-size:19px;

  display:flex;
  align-items:center;
  justify-content:center;

  cursor:pointer;
}


.claraInfoHeroIcon{
  width:52px;
  height:52px;

  margin-bottom:14px;

  border-radius:17px;

  background:#111214;

  color:#FDF05D;

  display:flex;
  align-items:center;
  justify-content:center;

  box-shadow:
    0 15px 32px rgba(17,24,39,.17);
}


.claraInfoModal h2{
  margin:
    13px 0 5px;

  color:#111827;

  font-size:25px;
  font-weight:800;

  line-height:1.1;

  letter-spacing:-.025em;
}


.claraInfoLead{
  margin:
    0 0 21px;

  color:#68707d;

  font-size:13px;
  font-weight:500;

  line-height:1.55;
}


.claraFeatureList{
  display:flex;
  flex-direction:column;

  gap:9px;
}


.claraFeature{
  display:flex;

  align-items:flex-start;

  gap:12px;

  padding:13px;

  border:
    1px solid rgba(17,24,39,.07);

  border-radius:17px;

  background:
    rgba(249,250,251,.82);
}


.claraFeatureIcon{
  width:29px;
  height:29px;

  flex:
    0 0 29px;

  display:flex;
  align-items:center;
  justify-content:center;

  border-radius:10px;

  background:
    rgba(253,240,93,.32);

  color:#111827;

  font-size:14px;
}


.claraFeature > div{
  display:flex;
  flex-direction:column;

  gap:3px;
}


.claraFeature strong{
  color:#111827;

  font-size:12px;
  font-weight:800;
}


.claraFeature div span{
  color:#68707d;

  font-size:11px;

  line-height:1.45;
}


.claraInfoCTA{
  width:100%;

  margin-top:20px;

  padding:
    13px 16px;

  border:none;

  border-radius:999px;

  background:#FDF05D;

  color:#111827;

  font-family:
    Montserrat,
    system-ui,
    sans-serif;

  font-size:13px;
  font-weight:800;

  display:flex;
  align-items:center;
  justify-content:space-between;

  cursor:pointer;
}


.claraInfoDisclaimer{
  margin-top:11px;

  text-align:center;

  color:#9ca3af;

  font-size:9px;
  font-weight:500;
}


/* =========================================================
   MOBILE CLARA
   ========================================================= */

@media(max-width:700px){

  .claraLaunchLayer{
    position:fixed;

    inset:0;

    z-index:2147483000;

    pointer-events:none;
  }


  .claraIntroCard{
    position:absolute;

    left:12px;
    right:12px;

    bottom:
      calc(
        100px +
        env(safe-area-inset-bottom)
      );

    width:auto;

    padding:
      18px 18px 17px;

    border-radius:22px;

    pointer-events:auto;

    background:
      radial-gradient(
        320px 160px at 100% 0%,
        rgba(253,240,93,.18),
        transparent 56%
      ),
      linear-gradient(
        145deg,
        rgba(255,255,255,.97),
        rgba(255,255,255,.88)
      );

    border:
      1px solid rgba(253,240,93,.58);

    -webkit-backdrop-filter:
      blur(24px);

    backdrop-filter:
      blur(24px);

    box-shadow:
      0 24px 65px rgba(15,23,42,.24),
      0 0 32px rgba(253,240,93,.12),
      inset 0 1px 0 rgba(255,255,255,.98);
  }


  .claraIntroTitle{
    font-size:19px;
  }


  .claraNameHighlight{
    font-size:26px;
  }


  .claraIntroText{
    font-size:11px;

    max-width:
      calc(100vw - 76px);
  }


  .claraFloat{
    position:absolute;

    right:16px;

    bottom:
      calc(
        18px +
        env(safe-area-inset-bottom)
      );

    width:64px;
    height:64px;

    pointer-events:auto;

    border:
      1px solid rgba(253,240,93,.72);

    box-shadow:
      0 20px 52px rgba(0,0,0,.36),
      0 0 0 5px rgba(253,240,93,.09),
      0 0 32px rgba(253,240,93,.25),
      inset 0 1px 0 rgba(255,255,255,.18);
  }


  .claraFloatLabel{
    right:52px;

    height:36px;

    padding:
      0 15px
      0 8px;

    gap:6px;

    box-shadow:
      0 12px 30px rgba(15,23,42,.18),
      0 0 19px rgba(253,240,93,.12),
      inset 0 1px 0 rgba(255,255,255,.98);
  }


  .claraFloatLabelName{
    font-size:10px;
  }


  .claraFloatLabelNew{
    font-size:7px;

    padding:
      3px 5px;
  }


  .claraFloatPulse{
    inset:-6px;
  }


  .claraOverlay{
    align-items:stretch;

    background:
      rgba(3,7,18,.18);
  }


  .claraDrawer{
    width:100vw;
    max-width:none;

    height:100vh;
    height:100dvh;

    max-height:100dvh;

    border-left:none;

    border-radius:0;
  }


  .claraDrawerHeader{
    flex:
      0 0
      calc(
        67px +
        env(safe-area-inset-top)
      );

    min-height:
      calc(
        67px +
        env(safe-area-inset-top)
      );

    padding:
      env(safe-area-inset-top)
      15px
      0;
  }


  .claraDrawerLogo{
    width:37px;
    height:37px;

    border-radius:13px;
  }


  .claraDrawerTitle{
    font-size:14px;
  }


  .claraDrawerSubtitle{
    font-size:9px;
  }


  .claraIframeWrap{
    width:100%;

    flex:1;

    min-height:0;

    overflow:hidden;
  }


  .claraIframe{
    width:100%;
    height:100%;

    min-height:0;

    border:0;
  }


  .claraInfoOverlay{
    padding:
      calc(
        12px +
        env(safe-area-inset-top)
      )
      12px
      calc(
        12px +
        env(safe-area-inset-bottom)
      );
  }


  .claraInfoModal{
    width:100%;

    max-height:
      calc(
        100dvh -
        24px -
        env(safe-area-inset-top) -
        env(safe-area-inset-bottom)
      );

    padding:22px;

    border-radius:23px;
  }

}



      /* --- Date chips --- */
      .dateWrap{display:flex;align-items:center;gap:8px;flex-wrap:wrap}
      .dateTxt{color:#111827;font-weight:600}
      .whenPill{
        background:#FDF05D;color:#000;border-radius:10px;
        padding:4px 8px;font-weight:800;
        border:1px solid rgba(0,0,0,.18);
        display:inline-flex;align-items:baseline;gap:6px
      }
      .whenBig{font-size:14px;line-height:1}
      @media (min-width:880px){.whenBig{font-size:16px}}

      /* --- Recap banner --- */
      .recap{ display:grid; grid-template-columns: max-content 1fr; gap:12px; align-items:stretch; }
      .recapTile{ min-height:140px; border-radius:16px; overflow:hidden; background:#000; border:1px solid rgba(15,23,42,0.10); backdrop-filter: blur(12px) }

      .recapVideo{ display:block; }
      .recapVideo video{
        display:block;
        height:150px;
        width:auto;
        object-fit:cover;
      }

      .recapCard{
        display:flex; align-items:center; justify-content:space-between; gap:16px;
        padding:14px 16px;
        background: linear-gradient(180deg, rgba(255,255,255,.98), rgba(249,250,251,.98));
        min-height:140px;
      }
      .recapText{ display:flex; flex-direction:column; gap:6px; padding-left: 7px; }
      .recapLabel{ font-size:12px; color:#6b7280; font-weight:700; letter-spacing:.2px }
      .recapValue{ font-size:36px; line-height:1; font-weight:800; color:#111827 }

      .recapCTA{
        display:inline-flex; align-items:center; gap:10px;
        padding:10px 14px; border-radius:999px; border:1px solid rgba(15,23,42,.16);
        background: rgba(255,255,255,0.96); color:#111827; cursor:pointer; font-weight:620;
        transition: filter .18s ease, transform .18s ease;
        white-space:nowrap;
      }
      .recapCTA:hover{ filter:brightness(1.02); transform:translateY(-1px) }

      @media (max-width:900px){
        .recap{ grid-template-columns: 1fr; }
        .recapTile{ height:130px; }
        .recapValue{ font-size:30px; }
      }

      /* Sidebar creators section */
      .sideCreators{
        margin-top:12px;
        padding-top:6px;
        border-top:1px solid rgba(255,255,255,0.08);
      }
      .sideCreatorsHeader{
        display:flex; align-items:center; justify-content:space-between;
        margin:8px 0 8px 0;
        color:#f5f5f5;
      }
      .sideCreatorsTitle{ font-weight:800; font-size:13px; letter-spacing:.2px; }
      .sideCreatorsHint{ font-size:11px; color:#b3b3b3; }
      .sideList{
        display:flex; flex-direction:column; gap:8px;
        max-height:220px; overflow:auto; padding-right:2px;
      }
      .sideCreatorBtn{
        display:flex; align-items:center; gap:10px; width:100%;
        background:rgba(255,255,255,0.06);
        border:1px solid rgba(255,255,255,0.10);
        border-radius:12px; padding:8px 10px; text-align:left;
        cursor:pointer; transition:transform .15s ease, background .15s ease;
        color:#f5f5f5;
      }
      .sideCreatorBtn:hover{ transform:translateY(-1px); background:rgba(255,255,255,0.10); }
      .sideAvatar{
        width:30px; height:30px; border-radius:50%; overflow:hidden; background:#333; flex:0 0 auto;
      }
      .sideAvatar img{ width:100%; height:100%; object-fit:cover; }
      .sideMeta{ display:flex; flex-direction:column; min-width:0; }
      .sideName{ font-weight:700; font-size:13px; overflow:hidden; text-overflow:ellipsis; white-space:nowrap; }
      .sideSub{ font-size:11px; color:#d1d5db; }

      .sideHelpBtn{
        margin-top:auto;
        width:100%;
        border-radius:14px;
        border:1px solid rgba(255,255,255,0.16);
        background:rgba(255,255,255,0.03);
        padding:9px 11px;
        font-size:11px;
        display:flex;
        flex-direction:column;
        gap:2px;
        color:#f5f5f5;
        cursor:pointer;
        text-align:left;
      }
      .sideHelpMain{
        font-weight:700;
        font-size:12px;
      }
      .sideHelpSub{
        font-size:11px;
        opacity:.85;
      }

      /* Calendar controls */
      .controlsBar{display:flex;flex-wrap:wrap;gap:8px;align-items:center;margin-bottom:8px}
      .searchBox{flex:1;min-width:180px;display:flex;align-items:center;gap:8px;background:#ffffff;border:1px solid #e5e7eb;border-radius:12px;padding:8px 10px}
      .searchBox input{all:unset;flex:1;font-size:14px;color:#111827;}
      .clearBtn{background:transparent;border:none;color:#6b7280;cursor:pointer}
      .sortSelect{border:1px solid #e5e7eb;background:#ffffff;color:#111827;border-radius:10px;padding:8px 10px;font-weight:700}

      /* Boot overlay */
      .bootOverlay{
        position:fixed; inset:0; z-index:9999;
        display:flex; align-items:center; justify-content:center;
        background:rgba(0,0,0,.75); backdrop-filter:blur(6px);
      }
      .spinner{
        width:42px; height:42px; border-radius:50%;
        border:3px solid rgba(255,255,255,.18); border-top-color:#FDF05D;
        animation:spin .9s linear infinite;
      }
      @keyframes spin { to { transform:rotate(360deg) } }
      .bootMsg{ font-weight:800; font-size:16px; margin-top:12px; color:#f9fafb; }

      /* Info button next to venue code */
      .infoBtn{
        width:18px;height:18px;border-radius:50%;
        border:1px solid rgba(156,163,175,0.9);
        background:transparent;
        color:#111827;
        font-size:11px;
        display:flex;align-items:center;justify-content:center;
        cursor:pointer;
      }

      .freemiumModal{
  width:min(460px,92vw);
  background:#fff;
  border-radius:24px;
  padding:22px;
  position:relative;
  text-align:center;
  border:1px solid rgba(17,24,39,0.08);
  box-shadow:0 30px 90px rgba(0,0,0,0.35);
}

.freemiumClose{
  position:absolute;
  top:12px;
  right:12px;
  width:30px;
  height:30px;
  border:none;
  border-radius:999px;
  background:#f3f3f3;
  font-size:18px;
  font-weight:900;
  cursor:pointer;
  color:#111827;
}

.freemiumClose.locked{
  opacity:.35;
  cursor:not-allowed;
}
.freemiumTitle{
  font-size:24px;
  line-height:1.15;
  font-weight:700;
  margin-bottom:15px;
  color:#111827;
}

.freemiumTryBtn{
  width:100%;
  border:none;
  border-radius:999px;
  padding:14px;
  background:#dcfce7;
  color:#166534;
  font-size:15px;
  font-weight:900;
  cursor:pointer;
}

.freemiumProof{
  margin-top:26px;
  background:#f8fafc;
  border:1px solid #e5e7eb;
  opacity:0.72;
  border-radius:14px;
  padding:9px 12px;
  display:flex;
  align-items:center;
  justify-content:center;
  gap:8px;
  font-size:12px;
  font-weight:700;
  color:#4b5563;
}

.suggestedListingInfoCard{
  display:flex;
  align-items:center;
  gap:12px;
  background:#eef7ff;
  border:1px solid #cfe7ff;
  border-radius:18px;
  padding:14px 16px;
  box-shadow:0 14px 35px rgba(15,23,42,0.06);
}

.suggestedListingInfoIcon{
  width:34px;
  height:34px;
  border-radius:999px;
  background:#dff0ff;
  color:#1f5d8f;
  display:flex;
  align-items:center;
  justify-content:center;
  font-weight:900;
  flex:0 0 auto;
}

.suggestedListingInfoText{
  flex:1;
  min-width:0;
}

.suggestedListingInfoTitle{
  font-size:14px;
  font-weight:800;
  color:#12334f;
  margin-bottom:3px;
}

.suggestedListingInfoSub{
  font-size:12px;
  color:#29445c;
  line-height:1.45;
}

.suggestedListingInfoBtn{
  border:none;
  border-radius:999px;
  background:#ffffff;
  color:#111827;
  font-weight:800;
  font-size:13px;
  padding:9px 12px;
  display:flex;
  align-items:center;
  gap:6px;
  cursor:pointer;
  white-space:nowrap;
  border:1px solid #cfe7ff;
}

.suggestedListingModal{
  width:min(460px,92vw);
  background:#fff;
  border-radius:24px;
  padding:22px;
  position:relative;
  text-align:center;
  border:1px solid rgba(17,24,39,0.08);
  box-shadow:0 30px 90px rgba(0,0,0,0.35);
}

.suggestedListingClose{
  position:absolute;
  top:12px;
  right:12px;
  width:30px;
  height:30px;
  border:none;
  border-radius:999px;
  background:#f3f3f3;
  font-size:18px;
  font-weight:900;
  cursor:pointer;
  color:#111827;
}

.suggestedListingClose.locked{
  opacity:.35;
  cursor:not-allowed;
}

.suggestedListingModalIcon{
  width:54px;
  height:54px;
  border-radius:999px;
  background:#eef7ff;
  border:1px solid #cfe7ff;
  display:flex;
  align-items:center;
  justify-content:center;
  margin:4px auto 14px;
  font-size:24px;
}

.suggestedListingModalTitle{
  font-size:23px;
  line-height:1.15;
  font-weight:850;
  margin-bottom:10px;
  color:#111827;
}

.suggestedListingModalSub{
  font-size:13px;
  color:#4b5563;
  line-height:1.5;
  margin-bottom:16px;
}

.suggestedListingMiniOffer{
  background:#f8fafc;
  border:1px solid #e5e7eb;
  border-radius:16px;
  padding:13px;
  margin-bottom:15px;
  text-align:left;
}

.suggestedListingMiniLabel{
  font-size:11px;
  font-weight:900;
  color:#6b7280;
  text-transform:uppercase;
  letter-spacing:.08em;
  margin-bottom:5px;
}

.suggestedListingMiniText{
  font-size:14px;
  font-weight:800;
  color:#111827;
  line-height:1.35;
}

.suggestedListingMiniValue{
  margin-top:5px;
  font-size:12px;
  color:#4b5563;
  font-weight:700;
}

.suggestedListingPrimaryBtn{
  width:100%;
  border:none;
  border-radius:999px;
  padding:14px;
  background:#FDF05D;
  color:#111827;
  font-size:14px;
  font-weight:900;
  cursor:pointer;
}

.suggestedListingGhostBtn{
  margin-top:9px;
  width:100%;
  border:none;
  border-radius:999px;
  padding:12px;
  background:#f3f3f3;
  color:#4b5563;
  font-size:13px;
  font-weight:800;
  cursor:pointer;
}

@media (max-width:700px){
  .suggestedListingInfoCard{
    align-items:flex-start;
    flex-direction:column;
  }

  .suggestedListingInfoBtn{
    width:100%;
    justify-content:center;
  }
}

.verifyTick{
  width:18px;
  height:18px;
  border-radius:999px;
  background:#1d9bf0;
  color:#fff;
  display:flex;
  align-items:center;
  justify-content:center;
  font-size:11px;
  font-weight:900;
  flex:0 0 auto;
}

.customerChatFloat{
  position:fixed;
right:103px;
bottom:28px;
  z-index:55;
  width:65px;
  height:65px;
  border-radius:999px;
  border:1px solid rgba(17,24,39,0.14);
  background:linear-gradient(#000000);
  color:#ffffff;
  box-shadow:0 18px 45px rgba(15,23,42,0.28);
  display:flex;
  align-items:center;
  justify-content:center;
  cursor:pointer;
  transition:transform .18s ease, box-shadow .18s ease, filter .18s ease;
}

.customerChatFloat:hover{
  transform:translateY(-2px);
  box-shadow:0 24px 60px rgba(15,23,42,0.34);
  filter:brightness(1.05);
}

.customerChatFloatPulse{
  position:absolute;
  top:9px;
  right:9px;
  width:10px;
  height:10px;
  border-radius:999px;
  background:#4CD964;
  border:2px solid #111827;
}

.customerSupportModal{
  width:min(500px,92vw);
  background:#ffffff;
  border-radius:24px;
  padding:22px;
  position:relative;
  border:1px solid rgba(17,24,39,0.08);
  box-shadow:0 30px 90px rgba(0,0,0,0.35);
  color:#111827;
}

.customerSupportClose{
  position:absolute;
  top:12px;
  right:12px;
  width:32px;
  height:32px;
  border:none;
  border-radius:999px;
  background:#f3f4f6;
  color:#111827;
  font-size:20px;
  font-weight:900;
  cursor:pointer;
  display:flex;
  align-items:center;
  justify-content:center;
}

.customerSupportClose:hover{
  background:#e5e7eb;
}

.customerSupportTop{
  display:flex;
  align-items:flex-start;
  gap:12px;
  padding-right:28px;
  margin-bottom:16px;
}

.customerSupportIcon{
  width:42px;
  height:42px;
  border-radius:999px;
  background:#111827;
  color:#FDF05D;
  display:flex;
  align-items:center;
  justify-content:center;
  flex:0 0 auto;
  box-shadow:0 12px 28px rgba(17,24,39,0.18);
}

.customerSupportTitle{
  font-size:20px;
  line-height:1.18;
  font-weight:900;
  color:#111827;
  margin:0;
}

.customerSupportSub{
  margin:7px 0 0;
  font-size:13px;
  line-height:1.45;
  color:#6b7280;
  font-weight:600;
}

.customerSupportForm{
  display:flex;
  flex-direction:column;
  gap:12px;
}

.customerSupportLabel{
  font-size:12px;
  font-weight:900;
  color:#111827;
  display:flex;
  align-items:center;
  justify-content:space-between;
  gap:8px;
}

.customerSupportRecommended{
  font-size:10px;
  font-weight:900;
  color:#166534;
  background:#dcfce7;
  border:1px solid #bbf7d0;
  border-radius:999px;
  padding:3px 8px;
}

.customerSupportTextarea,
.customerSupportInput{
  width:100%;
  border:1px solid #e5e7eb;
  background:#f9fafb;
  color:#111827;
  border-radius:16px;
  padding:12px 13px;
  font-family:Montserrat,system-ui,-apple-system,Segoe UI,Roboto,Helvetica,Arial,sans-serif;
  font-size:14px;
  outline:none;
  transition:border-color .16s ease, box-shadow .16s ease, background .16s ease;
}

.customerSupportTextarea{
  min-height:118px;
  resize:vertical;
  line-height:1.45;
}

.customerSupportTextarea:focus,
.customerSupportInput:focus{
  border-color:#111827;
  background:#ffffff;
  box-shadow:0 0 0 4px rgba(253,240,93,0.32);
}

.customerSupportError{
  background:#fef2f2;
  border:1px solid #fecaca;
  color:#991b1b;
  font-size:12px;
  font-weight:800;
  border-radius:14px;
  padding:10px 12px;
}

.customerSupportSuccess{
  background:#f0fdf4;
  border:1px solid #bbf7d0;
  color:#166534;
  font-size:13px;
  line-height:1.55;
  font-weight:800;
  border-radius:16px;
  padding:13px 14px;
}

.customerSupportRef{
  margin-top:10px;
  display:inline-flex;
  align-items:center;
  gap:6px;
  border-radius:999px;
  background:#ffffff;
  border:1px solid #bbf7d0;
  color:#166534;
  padding:6px 10px;
  font-size:12px;
  font-weight:900;
}

.customerSupportFaq{
  color:#166534;
  font-weight:900;
  text-decoration:underline;
}

.customerSupportSubmit{
  width:100%;
  border:none;
  border-radius:999px;
  padding:13px 14px;
  background:#FDF05D;
  color:#111827;
  font-size:14px;
  font-weight:950;
  cursor:pointer;
  box-shadow:0 12px 26px rgba(17,24,39,0.10);
}

.customerSupportSubmit:disabled{
  opacity:.55;
  cursor:not-allowed;
  box-shadow:none;
}


@media (max-width:700px){
  .customerChatFloat{
    right:84px;
    bottom:calc(19px + env(safe-area-inset-bottom));
    width:54px;
    height:54px;
  }
  .customerSupportModal{
    padding:20px;
    border-radius:22px;
  }

  .customerSupportTitle{
    font-size:18px;
  }
}
      .infoBtn:hover{
        background:rgba(243,244,246,0.9);
      }

      @media (max-width: 800px){
        .main{
          margin-left:230px;
        }
      }
    `;
    document.head.appendChild(style);
  }, []);

  // ------------------------------
  // Fetch: session + auth
  // ------------------------------
  useEffect(() => {
    fetch("https://collabbayadmin.com/APIControllers/GetSessionData.php", {
      credentials: "include",
    })
      .then((r) => r.json())
      .then((d) => {
        setUserData(d || {});
        if (!d?.Username) setShowLoginPrompt(true);
        if (d?.VenueCode) setVenueCode(d.VenueCode || "");
      })
      .catch(() => {
        setUserData({});
        setShowLoginPrompt(true);
      });
  }, []);



  // ------------------------------
// Guided onboarding tutorial card
// ------------------------------
useEffect(() => {
  if (!userData?.Username) {
    setShowDummyBookingPrompt(false);
    return;
  }

  let cancelled = false;

  setLoadingDummyBookingPrompt(true);

  fetch(
    "https://collabbayadmin.com/APIControllers/CheckDummyBookingPrompt.php",
    {
      credentials: "include",
      cache: "no-store",
    }
  )
    .then((r) => r.json())
    .then((d) => {
      if (cancelled) return;

      setShowDummyBookingPrompt(
        d?.success === true &&
        d?.showDummyBookingPrompt === true
      );
    })
    .catch((err) => {
      console.error("Tutorial card check failed:", err);

      if (!cancelled) {
        setShowDummyBookingPrompt(false);
      }
    })
    .finally(() => {
      if (!cancelled) {
        setLoadingDummyBookingPrompt(false);
      }
    });

  return () => {
    cancelled = true;
  };
}, [userData?.Username]);
  
useEffect(() => {
  if (!userData?.Username) return;

  fetch("https://collabbayadmin.com/APIControllers/CheckSuggestedListingsForBrand.php", {
    credentials: "include",
  })
    .then((r) => r.json())
    .then((d) => {
      if (!d?.success || !d?.hasSuggestedListing) return;

      setSuggestedListing(d.listing || null);

      const sessionKey = `collabbay_suggested_listing_modal_seen_${userData.Username}`;
      const alreadyShown = sessionStorage.getItem(sessionKey) === "Y";

      if (!alreadyShown) {
        sessionStorage.setItem(sessionKey, "Y");

        setTimeout(() => {
          setShowSuggestedListingModal(true);

          setTimeout(() => {
            setSuggestedListingCloseReady(true);
          }, 1000);
        }, 3000);
      }
    })
    .catch(() => {});
}, [userData?.Username]);

useEffect(() => {
  if (!userData?.Username) return;

  fetch("https://collabbayadmin.com/APIControllers/CheckIfSegmented.php", {
    credentials: "include",
  })
    .then((r) => r.json())
    .then((d) => {
      if (d?.success && d?.requiresSegmentation) {
        setShowSegmentModal(true);
      }
    })
    .catch(() => {});
}, [userData?.Username]);


  useEffect(() => {
    fetch("https://collabbayadmin.com/APIControllers/UserSubscriptionAuth.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
    })
      .then((r) => r.json())
.then((d) => {
  const ok = d?.authenticated === true;

  setIsAuthenticated(ok);
  setIsSubscriber(d?.auth_mode === "subscriber");
  setPlanStatusLoaded(true);

  setErrorMessage(ok ? "" : "Subscribe to access collabbay features");
})
.catch(() => {
  setPlanStatusLoaded(false);
  setErrorMessage("An error occurred while checking authentication.");
});
  }, []);





useEffect(() => {
  if (!userData?.Username) return;

  let cancelled = false;

  fetch("https://collabbayadmin.com/APIControllers/UserSubscriptionAuth.php", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
  })
    .then((r) => r.json())
    .then((d) => {
      if (cancelled) return;

      // Same access logic as the blocked side navigation elements
      if (d?.authenticated === true) return;

      const loginKey = `collabbay_login_count_${userData.Username}`;

      const currentCount =
        Number(localStorage.getItem(loginKey) || 0) + 1;

      localStorage.setItem(loginKey, String(currentCount));

      const sessionKey =
        `collabbay_freemium_seen_${userData.Username}`;

      const alreadyShownThisSession =
        sessionStorage.getItem(sessionKey) === "Y";

      const shouldShow =
        !alreadyShownThisSession &&
        Number(userData?.LoginCount || 0) > 5 &&
        currentCount >= 3 &&
        Math.random() < 0.3;

      if (shouldShow) {
        sessionStorage.setItem(sessionKey, "Y");

        setShowFreemiumPopup(true);

        setTimeout(() => {
          setFreemiumCloseReady(true);
        }, 3000);
      }
    })
    .catch(() => {
      // If the payment check fails, do not show the modal
    });

  return () => {
    cancelled = true;
  };
}, [userData?.Username]);








useEffect(() => {
  if (!showFreemiumPopup) return;

  const id = setInterval(() => {
    setFreemiumProofIndex((prev) =>
      (prev + 1) % freemiumProofs.length
    );
  }, 2500);

  return () => clearInterval(id);
}, [showFreemiumPopup]);
  // ------------------------------
  // Fetch: Recently online
  // ------------------------------
  useEffect(() => {
    fetch("https://collabbayadmin.com/APIControllers/RecentlyOnlineCreators.php")
      .then((r) => r.json())
      .then((d) => {
        if (d?.status === "success") {
          setRecentOnline(d.users || []);
          setRecentCount(d.count || 0);
        }
      })
      .catch(() => {});
  }, []);




  const getStableViewCount = (listingId, liveCount) => {
  const n = Number(liveCount || 0);

  // ✅ Do not show low view counts
  if (n <= 10) return 0;

  // ✅ Only refresh the visible number every 2 days per listing
  const key = `collabbay_visible_views_${listingId}`;
  const now = Date.now();
  const twoDays = 2 * 24 * 60 * 60 * 1000;

  try {
    const saved = JSON.parse(localStorage.getItem(key) || "null");

    // First time: save and show current count
    if (!saved) {
      localStorage.setItem(
        key,
        JSON.stringify({
          count: n,
          updatedAt: now,
        })
      );
      return n;
    }

    const savedCount = Number(saved.count || 0);
    const updatedAt = Number(saved.updatedAt || 0);

    // Only update visible count every 2 days, and only if it increased
    if (now - updatedAt >= twoDays && n > savedCount) {
      localStorage.setItem(
        key,
        JSON.stringify({
          count: n,
          updatedAt: now,
        })
      );
      return n;
    }

    // Keep showing the older visible number
    return savedCount > 10 ? savedCount : 0;
  } catch (e) {
    return n;
  }
};


const fetchViewCount = (listingId) => {
  return fetch(
    "https://collabbayadmin.com/APIControllers/FetchListingViewCount.php?ListingID=" +
      encodeURIComponent(listingId),
    { credentials: "include" }
  )
    .then((r) => r.json())
    .then((d) => {
      const liveCount = d?.ok ? Number(d.ListingViews || 0) : 0;
      return getStableViewCount(listingId, liveCount);
    })
    .catch(() => 0);
};


  // ------------------------------
  // Fetch: Suggested users (brand only)
  // ------------------------------
  useEffect(() => {
    if (!userData?.Username) return;
    setLoadingSuggested(true);
    fetch(
      "https://collabbayadmin.com/APIControllers/GetSuggestedUsersForBrand.php",
      { credentials: "include" }
    )
      .then((r) => r.json())
      .then((d) => setSuggestedUsers(d?.status === "success" ? d.users : []))
      .catch(() => setSuggestedUsers([]))
      .finally(() => setLoadingSuggested(false));
  }, [userData]);

  // ------------------------------
  // Fetch: Brand listings
  // ------------------------------
  const loadBrandListings = () => {
    fetch(
      "https://collabbayadmin.com/APIControllers/RetrieveBrandListings.php",
      { credentials: "include" }
    )
      .then((r) => r.json())
      .then((json) => {
        const filtered = Array.isArray(json)
          ? json.filter((x) => x.BrandName === userData?.Username)
          : [];
        setBrandListings(filtered);
      })
      .catch(() => setBrandListings([]));
  };
  useEffect(() => {
    if (!userData?.Username) return;
    loadBrandListings();
  }, [userData]);


useEffect(() => {
  if (!Array.isArray(brandListings) || brandListings.length === 0) return;

  let cancelled = false;
  const ids = brandListings.map((x) => x?.ListingID).filter(Boolean);

  Promise.all(ids.map((id) => fetchViewCount(id).then((v) => [id, v])))
    .then((pairs) => {
      if (cancelled) return;
      const next = {};
      pairs.forEach(([id, v]) => (next[id] = v));
      setListingViewsById(next);
    })
    .catch(() => {});

  return () => {
    cancelled = true;
  };
}, [brandListings]);


  // ------------------------------
  // Fetch: Collab count
  // ------------------------------
  const fetchTotalCollabCount = () => {
    fetch("https://collabbayadmin.com/APIControllers/GetCollabCount.php", {
      credentials: "include",
    })
      .then((r) => r.json())
      .then((d) => {
        if (d?.status === "success") setTotalCollabCount(d.count || 0);
      })
      .catch(() => {});
  };
  useEffect(() => {
    if (!userData?.Username) return;
    fetchTotalCollabCount();
  }, [userData]);

  // ------------------------------
  // Fetch: Collabs (calendar)
  // ------------------------------
  const loadCollabs = () => {
    setLoadingCollabs(true);
    fetch("https://collabbayadmin.com/APIControllers/GetCollabCalendar.php", {
      credentials: "include",
    })
      .then((r) => r.json())
      .then((data) => {
        const filtered = (Array.isArray(data) ? data : []).filter(
          (c) => c.BrandNotInterested !== "Y"
        );
        setCollabs(filtered);
      })
      .catch(() => setCollabs([]))
      .finally(() => {
        setLoadingCollabs(false);
        setBoot(false);
      });
  };
 useEffect(() => {
  // Load when dashboard first opens
  loadCollabs();

  // Reload whenever user comes back to this screen
  const unsubscribe = navigation.addListener("focus", () => {
    loadCollabs();
  });

  return unsubscribe;
}, [navigation]);
  // ------------------------------
  // Fetch: Missed bookings
  // ------------------------------
  useEffect(() => {
    fetch("https://collabbayadmin.com/APIControllers/GetMissedBookings.php", {
      credentials: "include",
    })
      .then((r) => r.json())
      .then((d) => {
        if (Array.isArray(d)) {
          setMissedCollabs(d);
        } else if (Array.isArray(d?.collabs)) {
          setMissedCollabs(d.collabs);
        } else {
          setMissedCollabs([]);
        }
      })
      .catch(() => {
        setMissedCollabs([]);
      });
  }, []);

  // ------------------------------
  // Fetch: “in-venue now” window
  // ------------------------------
  const fetchCurrentCollabData = () => {
    fetch(
      "https://collabbayadmin.com/APIControllers/GetCollabCalendarCurrent.php"
    )
      .then((r) => r.json())
      .then((data) => {
        const now = new Date();
        const oneHourBefore = new Date(now.getTime() - 60 * 60 * 1000);
        const fiveHoursAfter = new Date(now.getTime() + 5 * 60 * 60 * 1000);
        const filtered = (Array.isArray(data) ? data : []).filter((c) => {
          const t = new Date(c?.CreditAvailableStart);
          return c?.Status === "Accepted" && t >= oneHourBefore && t <= fiveHoursAfter;
        });
        setAlertCollabs(filtered);
        if (filtered.length > 0) {
          setCurrentCollab(filtered[0]);
        }
      })
      .catch(() => {});
  };
  useEffect(() => {
    fetchCurrentCollabData();
  }, []);

  // ------------------------------
  // Fetch: RAG (content due)
  // ------------------------------
  const loadRAG = () => {
    setLoadingRAG(true);
    fetch(
      "https://collabbayadmin.com/APIControllers/BrandGetContentRAG.php",
      { credentials: "include" }
    )
      .then((r) => r.json())
      .then((d) => {
        if (d?.success) {
          const filtered = (d.results || []).filter(
            (x) => x.Status === "YELLOW" || x.Status === "RED"
          );
          setRagItems(filtered);
        } else setRagItems([]);
      })
      .catch(() => setRagItems([]))
      .finally(() => setLoadingRAG(false));
  };
  useEffect(() => {
    if (!userData?.Username) return;
    loadRAG();
  }, [userData]);

  // ------------------------------
  // Helpers
  // ------------------------------
  const getOrdinalSuffix = (d) => {
    if (d > 3 && d < 21) return "th";
    switch (d % 10) {
      case 1:
        return "st";
      case 2:
        return "nd";
      case 3:
        return "rd";
      default:
        return "th";
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    if (isNaN(date)) return "";
    const day = date.getDate();
    const month = date.toLocaleString("default", { month: "long" });
    const hours = date.getHours() % 12 || 12;
    const minutes = date.getMinutes().toString().padStart(2, "0");
    const ampm = date.getHours() >= 12 ? "PM" : "AM";
    const today = new Date();
    const diffDays = Math.floor(
      (Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()) -
        Date.UTC(today.getFullYear(), today.getMonth(), today.getDate())) /
        (1000 * 60 * 60 * 24)
    );
    const when =
      diffDays === 0
        ? "today"
        : diffDays > 0
        ? `in ${diffDays} day${diffDays > 1 ? "s" : ""}`
        : `${Math.abs(diffDays)} day${
            Math.abs(diffDays) > 1 ? "s" : ""
          } ago`;
    return `${day}${getOrdinalSuffix(day)} ${month} ${hours}:${minutes}${ampm} (${when})`;
  };

  const formatDateParts = (dateString) => {
    const date = new Date(dateString);
    if (isNaN(date)) return { main: "", when: "" };

    const day = date.getDate();
    const month = date.toLocaleString("default", { month: "long" });
    const hours = date.getHours() % 12 || 12;
    const minutes = date.getMinutes().toString().padStart(2, "0");
    const ampm = date.getHours() >= 12 ? "PM" : "AM";
    const main = `${day}${getOrdinalSuffix(day)} ${month} ${hours}:${minutes}${ampm}`;

    const today = new Date();
    const diffDays = Math.floor(
      (Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()) -
        Date.UTC(today.getFullYear(), today.getMonth(), today.getDate())) /
        (1000 * 60 * 60 * 24)
    );

    const when =
      diffDays === 0
        ? "today"
        : diffDays > 0
        ? `in ${diffDays} day${diffDays > 1 ? "s" : ""}`
        : `${Math.abs(diffDays)} day${
            Math.abs(diffDays) > 1 ? "s" : ""
          } ago`;

    return { main, when };
  };

  function EmphasizedWhen({ text }) {
    const parts = String(text).split(/(\d+)/);
    return (
      <>
        {parts.map((p, i) =>
          /^\d+$/.test(p) ? (
            <strong key={i} className="whenBig">
              {p}
            </strong>
          ) : (
            p
          )
        )}
      </>
    );
  }

  const getStatus = (c) => {
    if (c?.Status === "Invited") return "Invited";
    if (c?.Status === "Cancelled") return "Cancelled";
    const now = new Date();
    const credit = new Date(c?.CreditAvailableStart);
    if (credit < now) return c?.Redeemed ? "Redeemed" : "Expired";
    if (c?.Status === "Accepted") return "Upcoming";
    if (c?.Status === "Pending") return "Pending";
    return "Pending";
  };

  const statusClass = (s) => {
    const m = {
      Expired: "expired",
      Redeemed: "redeemed",
      Upcoming: "upcoming",
      Pending: "pending",
      Cancelled: "cancelled",
      Invited: "invited",
    };
    return m[s] || "pending";
  };

  const navigateTo = (screen, params) => {


    const subscriptionGated = [
  "BrowseInviteCreators",
  "MyCalendar",
  "MyActivityFeed",
  "ContentBank",
  "BrandAIAnalysis",
  "MyReviews",
];


    if (!userData?.Username && screen !== "LogInPage" && screen !== "SignUpPage") {
      return navigation.navigate("LogInPage");
    }
    if (!isAuthenticated && subscriptionGated.includes(screen)) {
      return openSubscribe();
    }
    navigation.navigate(screen, params);
  };

  const openSubscribe = () => {
    // ✅ Always hard-reload the real subscribe page on collabbayadmin.com
    if (typeof window !== "undefined" && window.location) {
      window.location.href = "https://collabbayadmin.com/plans";
      return;
    }

    // Fallback (in case this ever runs in a purely native environment)
    if (navigation?.navigate) {
      navigation.navigate("PaymentPage");
    }
  };

const openPreviewBooking = (c) => {
  navigation.navigate("PreviewBooking", {
    CollabID: c?.CollabID,
    Promoter: c?.Promoter,     // ✅ this is the creator username
    Username: c?.Promoter,     // ✅ optional (your PreviewBooking supports this too)
  });
};

  const handleRowClick = (c) => {
    const freeRow =
      !isAuthenticated &&
      trialFreeCollabID &&
      c?.CollabID === trialFreeCollabID;

    // not logged in -> go login
    if (!userData?.Username) {
      return navigation.navigate("LogInPage");
    }

    // logged in but not subscribed -> blurred rows go to PreviewBooking
    if (!isAuthenticated && !freeRow) {
      return openPreviewBooking(c);
    }

    // subscribed (or freeRow) -> real booking request
    navigation.navigate("BookingRequest", { CollabID: c?.CollabID });
  };




const handleNotInterested = async (e, collabID) => {
  // Prevent the booking row itself opening
  e.stopPropagation();

  if (hidingCollabID) return;

  const confirmed = window.confirm(
    "Not interested?\n\nWe'll remove this request from your feed."
  );

  if (!confirmed) return;

  try {
    setHidingCollabID(collabID);

    const response = await fetch(
      "https://collabbayadmin.com/APIControllers/BrandHideInfluencerRequest.php",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
        body: JSON.stringify({
          CollabID: collabID,
        }),
      }
    );

    const data = await response.json();

    if (data?.Status === "Success") {
      // Remove immediately from desktop feed
      setCollabs((prev) =>
        prev.filter((collab) => collab.CollabID !== collabID)
      );
    } else {
      window.alert(
        data?.Message || "Couldn’t hide request. Please try again."
      );
    }
  } catch (error) {
    console.error("Hide request error:", error);

    window.alert(
      "Couldn’t hide request. Please check your connection and try again."
    );
  } finally {
    setHidingCollabID(null);
  }
};





  const handleEditBanner = (listingID) => {
    const url = `https://collabbayadmin.com/ListingImageUpload.html?ListingID=${encodeURIComponent(
      listingID
    )}`;
    window.open(url, "_blank", "noopener");
  };



const openCustomerQueryModal = () => {
  setCustomerQueryError("");
  setCustomerQuerySuccess("");
  setCustomerQueryRef("");
  setShowCustomerQueryModal(true);
};

const closeCustomerQueryModal = () => {
  setShowCustomerQueryModal(false);
};

const handleHelpClick = () => {
  openCustomerQueryModal();
};


const openClara = () => {
  // Clara is currently for paying subscribers only.
  if (!isSubscriber) return;

  setShowClaraIntro(false);
  setShowClara(true);
};

const closeClara = () => {
  setShowClara(false);
};

const openClaraInfo = () => {
  if (!isSubscriber) return;

  setShowClaraInfo(true);
};

const isValidCustomerPhone = (phone) => {
  const value = String(phone || "").trim();
  if (!value) return true;

  const compact = value.replace(/[()\s.-]/g, "");
  return /^\+?[0-9]{7,15}$/.test(compact);
};

const submitCustomerQuery = (e) => {
  e.preventDefault();

  const message = customerQueryMessage.trim();
  const phone = customerQueryPhone.trim();

  setCustomerQueryError("");
  setCustomerQuerySuccess("");
  setCustomerQueryRef("");

  if (!message) {
    setCustomerQueryError("Please enter a message before sending.");
    return;
  }

  if (!isValidCustomerPhone(phone)) {
    setCustomerQueryError("Please enter a valid phone number, or leave it blank.");
    return;
  }

  if (customerQuerySubmitting) return;

  setCustomerQuerySubmitting(true);

  fetch("https://collabbayadmin.com/APIControllers/LiveBrandCustomerQuery.php", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
    body: JSON.stringify({
      message,
      phone,
    }),
  })
    .then((r) => r.json())
    .then((d) => {
      if (d?.success) {
        setCustomerQuerySuccess(
          "We'll be in touch as soon as possible- thanks for getting in touch"
        );
        setCustomerQueryRef(d.referenceId || "");
        setCustomerQueryMessage("");
        setCustomerQueryPhone("");
      } else {
        setCustomerQueryError(d?.message || "Could not send your message. Please try again.");
      }
    })
    .catch(() => {
      setCustomerQueryError("Could not send your message. Please try again.");
    })
    .finally(() => {
      setCustomerQuerySubmitting(false);
    });
};

  const handleFaqClick = () => {
    window.location.href = "https://collabbayadmin.com/FAQs";
  };

  const handleMapClick = () => {
    window.location.href = "https://collabbayadmin.com/venues";
  };



const submitBrandSegment = () => {
  if (!segmentQuality || !segmentRhythm || segmentSaving) return;

  setSegmentSaving(true);
  setSegmentError("");

  fetch("https://collabbayadmin.com/APIControllers/UpdateBrandSegment.php", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
    body: JSON.stringify({
      qualityInput: segmentQuality,
      rhythmInput: segmentRhythm,
    }),
  })
    .then((r) => r.json())
    .then((d) => {
      if (d?.success) {
    setUserData((prev) => ({
  ...prev,
  BrandSegment: d.BrandSegment,
}));
        setShowSegmentModal(false);
        setSegmentStep(1);
        setSegmentQuality("");
        setSegmentRhythm("");
      } else {
        setSegmentError(d?.message || "Could not save your preferences.");
      }
    })
    .catch(() => {
      setSegmentError("Could not save your preferences.");
    })
    .finally(() => {
      setSegmentSaving(false);
    });



};




const dummyBookingDate = useMemo(() => {
  const d = new Date();
  d.setDate(d.getDate() + 5);
  d.setHours(19, 0, 0, 0);
  return d;
}, []);

  // ------------------------------
  // Render
  // ------------------------------

  return (
    <div className="wrap">




{/* Clara floating launcher + introduction */}
{userData?.Username && planStatusLoaded && isSubscriber && (
  <div className="claraLaunchLayer">

    {showClaraIntro && !showClara && (
      <div className="claraIntroCard">

        <button
          type="button"
          className="claraIntroClose"
          onClick={() => setShowClaraIntro(false)}
          aria-label="Dismiss Clara introduction"
        >
          ×
        </button>

        <div className="claraIntroTop">
          <span className="claraNewBadge">
            NEW
          </span>

          <button
            type="button"
            className="claraInfoMini"
            onClick={openClaraInfo}
            aria-label="What can Clara do?"
            title="What can Clara do?"
          >
            i
          </button>
        </div>

        <div className="claraIntroEyebrow">
          ✦ NEW TO YOUR ACCOUNT
        </div>

        <div className="claraIntroTitle">
          Meet <strong>{userData.Username}'s</strong>
          <br />
          new AI assistant,
          <br />
          <span className="claraNameHighlight">
            Clara™
          </span>
        </div>

        <div className="claraIntroText">
          Your AI influencer manager, now built directly into Collabbay.
        </div>

        <button
          type="button"
          className="claraIntroCTA"
          onClick={openClara}
        >
          <span>Meet Clara</span>

          <span className="claraIntroArrow">
            →
          </span>
        </button>

      </div>
    )}


    <button
      type="button"
      className="claraFloat"
      onClick={openClara}
      aria-label="Open Clara"
      title="Chat with Clara"
    >

      <span className="claraFloatPulse" />

      <span className="claraFloatLabel">
        <span className="claraFloatLabelNew">
          NEW
        </span>

        <span className="claraFloatLabelName">
          Clara™
        </span>
      </span>

      <span className="claraFloatInner">
        <ClaraIcon size={28} />
      </span>

      <span className="claraOnlineDotFloat" />

    </button>

  </div>
)}

<button
  type="button"
  className="customerChatFloat"
  onClick={openCustomerQueryModal}
  aria-label="Contact Collabbay support"
  title="Contact Collabbay support"
>
  <span className="customerChatFloatPulse" />
  <svg width="25" height="25" viewBox="0 0 24 24" fill="none" aria-hidden>
    <path
      d="M4 5.5C4 4.12 5.12 3 6.5 3h11C18.88 3 20 4.12 20 5.5v7C20 13.88 18.88 15 17.5 15H9l-5 4V5.5Z"
      stroke="#FDF05D"
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <path
      d="M8 8h8M8 11h5"
      stroke="#FDF05D"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
</button>

      {showSuggestedListingModal && suggestedListing && (
  <div className="modalOverlay">
    <div className="suggestedListingModal">
      <button
        className={`suggestedListingClose ${!suggestedListingCloseReady ? "locked" : ""}`}
        onClick={() => {
          if (!suggestedListingCloseReady) return;
          setShowSuggestedListingModal(false);
        }}
      >
        ×
      </button>

      <div className="suggestedListingModalIcon">✨</div>

      <div className="suggestedListingModalTitle">
        Our team has hand-prepared something for you...
      </div>

      <div className="suggestedListingModalSub">
        We’ve prepped an offer you can edit and post as needed. It’s based on your account details and what tends to perform well on collabbay™.
      </div>

      <div className="suggestedListingMiniOffer">
        <div className="suggestedListingMiniLabel">Suggested offer</div>
        <div className="suggestedListingMiniText">
          {suggestedListing?.NonCreditOffer || "Prepared offer"}
        </div>

        {suggestedListing?.Credits ? (
          <div className="suggestedListingMiniValue">
            Rough value: £{suggestedListing.Credits}
          </div>
        ) : null}
      </div>

      <button
        className="suggestedListingPrimaryBtn"
        onClick={() => {
  window.location.href =
    `https://collabbayadmin.com/Introduction.html?Brand=${encodeURIComponent(userData.Username)}`;
}}
      >
        View my suggested offer
      </button>

      <button
        className="suggestedListingGhostBtn"
        onClick={() => setShowSuggestedListingModal(false)}
      >
        Not now
      </button>
    </div>
  </div>
)}

{false && (
  <div className="modalOverlay">
    <div className="freemiumModal">

      <button
        className={`freemiumClose ${!freemiumCloseReady ? "locked" : ""}`}
        onClick={() => {
          if (!freemiumCloseReady) return;
          setShowFreemiumPopup(false);
        }}
      >
        ×
      </button>

<div className="freemiumTitle">
  Want to fill {userData?.BrandName || "your venue"} with{" "}
  <strong>customers</strong>, our premium creators and none of the faff?
</div>


<button
  className="freemiumTryBtn"
  onClick={openSubscribe}
>
  <span
    style={{
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: 8,
      color: "#166534",
      fontWeight: 900,
    }}
  >
    <span
      style={{
        width: 18,
        height: 18,
        borderRadius: 999,
        background: "#22c55e",
        color: "#fff",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: 11,
        fontWeight: 900,
      }}
    >
      ✓
    </span>

    Try boosted footfall with full access
  </span>
</button>

      <div className="freemiumProof">
        <span className="verifyTick">✓</span>

        <span>
          {freemiumProofs[freemiumProofIndex]}
        </span>
      </div>

    </div>
  </div>
)}

{showSegmentModal && (
  <div className="modalOverlay" role="dialog" aria-modal="true">
    <div
      className="modal"
      style={{
        maxWidth: 620,
        borderRadius: 28,
        padding: 28,
        border: "1px solid rgba(17,24,39,0.08)",
        boxShadow: "0 30px 90px rgba(0,0,0,0.32)",
      }}
    >
      <div style={{ display: "flex", flexDirection: "column", gap: 18 }}>
        <div>
          <div
            style={{
              fontSize: 11,
              fontWeight: 900,
              color: "#6b7280",
              letterSpacing: "0.16em",
              textTransform: "uppercase",
              marginBottom: 8,
            }}
          >
            Customisation
          </div>

          <div style={{ fontSize: 30, fontWeight: 950, color: "#111827", lineHeight: 1.08 }}>
            <span
              style={{
                background: "linear-gradient(90deg, #111827 0%, #d6c900 45%, #FDF05D 100%)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
              }}
            >
              Tailor
            </span>{" "}
            your collabs
          </div>

          <div style={{ display: "flex", gap: 7, marginTop: 18 }}>
            {[1, 2, 3].map((n) => (
              <span
                key={n}
                style={{
                  width: segmentStep === n ? 24 : 8,
                  height: 8,
                  borderRadius: 999,
                  background: segmentStep === n ? "#111827" : "#e5e7eb",
                  transition: "all 0.2s ease",
                }}
              />
            ))}
          </div>
        </div>

        {segmentStep === 1 && (
          <>
            <div style={{ fontSize: 17, fontWeight: 900, color: "#111827" }}>
              How would someone describe your venue?
            </div>

            <div style={{ display: "grid", gap: 10 }}>
{[
  { label: "Michelin-starred", badge: "★ £££" },
  { label: "Refined Elegance", badge: "£££" },
  { label: "Local Gem", badge: "££" },
  { label: "Casual and Quick", badge: "£" },
].map((item) => {
  const option = item.label;
  const selected = segmentQuality === option;

  return (
    <button
      key={option}
      type="button"
      onClick={() => setSegmentQuality(option)}
      style={{
        width: "100%",
        padding: "15px 16px",
        borderRadius: 16,
        border: selected ? "2px solid #111827" : "1px solid #e5e7eb",
        background: selected ? "rgba(253,240,93,0.35)" : "#ffffff",
        color: "#111827",
        fontWeight: 850,
        textAlign: "left",
        cursor: "pointer",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        boxShadow: selected ? "0 10px 26px rgba(17,24,39,0.08)" : "none",
      }}
    >
      <span>{option}</span>

      <span style={{ display: "flex", alignItems: "center", gap: 10 }}>
        <span
          style={{
            background: "#f3f3f3",
            border: "1px solid #e5e7eb",
            borderRadius: 999,
            padding: "5px 10px",
            fontSize: 11,
            fontWeight: 900,
            color: "#111827",
          }}
        >
          {item.badge}
        </span>

        <span
          style={{
            width: 18,
            height: 18,
            borderRadius: 999,
            border: selected ? "6px solid #111827" : "2px solid #d1d5db",
            background: "#fff",
          }}
        />
      </span>
    </button>
  );
})}
            </div>

            <button
              type="button"
              className="ctaBtn"
              disabled={!segmentQuality}
              onClick={() => setSegmentStep(2)}
              style={{
                opacity: segmentQuality ? 1 : 0.45,
                padding: "13px 16px",
                borderRadius: 999,
                marginTop: 4,
              }}
            >
              Next
            </button>
          </>
        )}

        {segmentStep === 2 && (
          <>
            <div style={{ fontSize: 17, fontWeight: 900, color: "#111827" }}>
              What rhythm of influencer collab-requests suit your business?
            </div>

            <div style={{ display: "grid", gap: 10 }}>
            {[
  { label: "Any interest that we can get", badge: "▲▲▲" },
  { label: "A steady flow to choose from", badge: "▲▲" },
  { label: "Occasional, select collabs", badge: "▲" },
].map((item) => {
  const option = item.label;
  const selected = segmentRhythm === option;

  return (
    <button
      key={option}
      type="button"
      onClick={() => setSegmentRhythm(option)}
      style={{
        width: "100%",
        padding: "15px 16px",
        borderRadius: 16,
        border: selected ? "2px solid #111827" : "1px solid #e5e7eb",
        background: selected ? "rgba(253,240,93,0.35)" : "#ffffff",
        color: "#111827",
        fontWeight: 850,
        textAlign: "left",
        cursor: "pointer",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        boxShadow: selected ? "0 10px 26px rgba(17,24,39,0.08)" : "none",
      }}
    >
      <span>{option}</span>

      <span style={{ display: "flex", alignItems: "center", gap: 10 }}>
        <span
          style={{
            background: "#f3f3f3",
            border: "1px solid #e5e7eb",
            borderRadius: 999,
            padding: "5px 10px",
            fontSize: 11,
            fontWeight: 900,
            color: "#111827",
            letterSpacing: "0.08em",
          }}
        >
          {item.badge}
        </span>

        <span
          style={{
            width: 18,
            height: 18,
            borderRadius: 999,
            border: selected ? "6px solid #111827" : "2px solid #d1d5db",
            background: "#fff",
          }}
        />
      </span>
    </button>
  );
})}
            </div>

            <div style={{ display: "flex", gap: 10, marginTop: 4 }}>
              <button type="button" className="ghostBtn" onClick={() => setSegmentStep(1)} style={{ borderRadius: 999 }}>
                Back
              </button>

              <button
                type="button"
                className="ctaBtn"
                disabled={!segmentRhythm}
                onClick={() => setSegmentStep(3)}
                style={{
                  flex: 1,
                  opacity: segmentRhythm ? 1 : 0.45,
                  borderRadius: 999,
                }}
              >
                Next
              </button>
            </div>
          </>
        )}

        {segmentStep === 3 && (
          <>
            <div style={{ fontSize: 17, fontWeight: 900, color: "#111827" }}>
              Confirm your preferences
            </div>

            <div
              style={{
                background: "linear-gradient(180deg,#ffffff,#f9fafb)",
                border: "1px solid #e5e7eb",
                borderRadius: 18,
                padding: 16,
                display: "grid",
                gap: 10,
              }}
            >
              <div><strong>Venue style:</strong> {segmentQuality}</div>
              <div><strong>Collab rhythm:</strong> {segmentRhythm}</div>
            </div>

            {segmentError ? (
              <div style={{ color: "#eb5757", fontWeight: 800 }}>{segmentError}</div>
            ) : null}

            <div style={{ display: "flex", gap: 10, marginTop: 4 }}>
              <button
                type="button"
                className="ghostBtn"
                onClick={() => setSegmentStep(2)}
                disabled={segmentSaving}
                style={{ borderRadius: 999 }}
              >
                Back
              </button>

              <button
                type="button"
                className="ctaBtn"
                onClick={submitBrandSegment}
                disabled={segmentSaving}
                style={{
                  flex: 1,
                  borderRadius: 999,
                  padding: "13px 16px",
                }}
              >
                {segmentSaving ? "Saving…" : "Confirm"}
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  </div>
)}

      {boot && (
        <div className="bootOverlay">
          <div>
            <div className="spinner" />
            <div className="bootMsg">{bootMsg}</div>
          </div>
        </div>
      )}

      {/* Sidebar */}
      <aside className="sidebar">
        <div className="logoRow">
          <span className="logo">
            <img
              alt="Collabbay"
              src="https://collabbayadmin.com/CollabbayLogoDark.png"
            />
          </span>
          <div>
            <div className="appName">
              collab<b>bay.</b>
            </div>
            <div className="modeTag">DESKTOP</div>
          </div>
        </div>

        <div className="nav">
          <button onClick={() => navigation.navigate("MyPanel")}>
            <DotIcon /> Home
          </button>

          <button
            onClick={() => {
              if (userData?.Username) navigateTo("MyOffers");
              else navigation.navigate("LogInPage");
            }}
          >
            <LaptopIcon /> My Offers
          </button>

          <button onClick={() => navigateTo("BrowseCreators")}>
            <SearchIcon /> Browse Creators{" "}
            {userData?.Username && !isAuthenticated ? (
              <span className="pill">Locked</span>
            ) : null}
          </button>

          <button onClick={() => navigateTo("MyCalendar")}>
            <CalendarIcon /> Calendar{" "}
            {userData?.Username && !isAuthenticated ? (
              <span className="pill">Locked</span>
            ) : null}
          </button>

          <button onClick={() => navigateTo("MyActivityFeed")}>
            <ChatIcon /> Activity{" "}
            {userData?.Username && !isAuthenticated ? (
              <span className="pill">Locked</span>
            ) : null}
          </button>


<button onClick={() => navigateTo("ContentBank")}>
  <ContentIcon /> My Content Bank{" "}
  {userData?.Username && !isAuthenticated ? (
    <span className="pill">Locked</span>
  ) : null}
</button>



<button onClick={() => navigateTo("BrandAIAnalysis")}>
  <BoltIcon /> Brand AI Analysis{" "}
  {userData?.Username && !isAuthenticated ? (
    <span className="pill">Locked</span>
  ) : null}
</button>

<button onClick={() => navigateTo("MyReviews")}>
  <DotIcon /> Review Tool <span className="newBadge">New</span>
  {userData?.Username && !isAuthenticated ? (
    <span className="pill">Locked</span>
  ) : null}
</button>


{userData?.Username && planStatusLoaded && isSubscriber && (
  <button
    type="button"
    className="claraNavButton"
    onClick={openClara}
    title="Open Clara"
  >
    <ClaraIcon size={16} />

    <span>Clara™</span>

    <span className="claraNavNew">
      New
    </span>
  </button>
)}


          <button
            onClick={() => {
              if (userData?.Username) navigateTo("BusinessAccountPage");
              else window.location.href = "https://collabbayadmin.com/SignIn";
            }}
          >
            <UserIcon /> Account
          </button>

          <button className="cta" onClick={() => navigateTo("GuidedOfferSetup")}>
            + Create offer
          </button>
        </div>

        {/* Upgrade CTA in sidebar */}
        {userData?.Username && !isAuthenticated && (
          <button className="upgradeBtn" onClick={openSubscribe}>
            <span className="upgradeBtnTitleOnly">Unlock full access</span>
          </button>
        )}

        {/* Q&A: CTA / FAQ / MAP */}
        <div className="sideActions">
          {/* What is this? -> FAQ */}
          <button className="sideActionCard" type="button" onClick={handleFaqClick}>
            <div className="sideActionTitle">New? FAQ Page</div> <span className="newBadge">New</span>
            <div className="sideActionSubtitle">Read the Collabbay FAQ</div>
          </button>

          {/* Who else is using it? -> MAP + DATA */}
          <button
            type="button"
            className="sideActionCard"
            onClick={handleMapClick}
          >
            <div className="mapActionRow">
              <MapIcon />
              <div>
                <div className="sideActionTitle">
                  See your peers <span className="newBadge">New</span>
                </div>
                <div className="sideActionSubtitle">
                  View venues using Collabbay
                </div>
              </div>
            </div>
          </button>
        </div>

        {/* Sidebar: Suggested creators */}
        {userData?.Username && (
          <div className="sideCreators">
            <div className="sideCreatorsHeader">
              <div className="sideCreatorsTitle">Suggested creators</div>
              <div className="sideCreatorsHint">Tap to invite</div>
            </div>

            {loadingSuggested ? (
              <div className="muted" style={{ fontSize: 12 }}>
                Loading…
              </div>
            ) : suggestedUsers?.length > 0 ? (
              <div className="sideList">
                {suggestedUsers.map((u, i) => {
                  const subject = `Collab invite from ${userData.Username}`;
                  const body = `Hi ${u.Username},\n\nWe'd love to collaborate with you on Collabbay! Check out our offer and let us know if you're interested.\n\nYou can visit Collabbay to check it out and book to visit us.\n\nThanks,\n${userData.Username}`;
                  const mailto = `mailto:${u.UserEmail}?subject=${encodeURIComponent(
                    subject
                  )}&body=${encodeURIComponent(body)}`;
                  return (
                    <button
                      key={i}
                      className="sideCreatorBtn"
                      onClick={() => (window.location.href = mailto)}
                      title={`Invite ${u.Username}`}
                    >
                      <span className="sideAvatar">
                        <img alt="" src={u.ProfileImage} />
                      </span>
                      <div className="sideMeta">
                        <div className="sideName">{u.Username}</div>
                        <div className="sideSub">
                          {u.PlatformFollowers} followers
                        </div>
                      </div>
                      <ChevronRightIcon size={16} />
                    </button>
                  );
                })}
              </div>
            ) : (
              <div className="muted" style={{ fontSize: 12 }}>
                No suggestions yet
              </div>
            )}
          </div>
        )}


      </aside>

      {/* Main */}
      <main className="main">
        {/* Top banner */}
        <div className="top">
<div className="hello">


<button
  type="button"
  className={`hiAvatarBtn ${
    userData?.ProfileImage && String(userData.ProfileImage).trim()
      ? ""
      : "hiAvatarBtn--empty"
  }`}
  onClick={() =>
    (window.location.href =
      "https://collabbayadmin.com/UpdateProfile.html")
  }
  title="Edit your logo"
  aria-label="Edit your logo"
>
  {userData?.ProfileImage && String(userData.ProfileImage).trim() ? (
    <img alt="" src={userData.ProfileImage} />
  ) : (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden>
      <path
        d="M12 20h9"
        stroke="#ffffff"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4 12.5-12.5Z"
        stroke="#ffffff"
        strokeWidth="2"
        strokeLinejoin="round"
      />
    </svg>
  )}
</button>


  <div>


<div className="helloTitleRow">
  <div className="hi">
    Hi{userData?.Username ? `, ${userData.Username}` : ""} 👋
  </div>

  

  {userData?.Username && planStatusLoaded && (
  <button
    type="button"
    className="accountPlanBadge"
    onClick={() => {
      window.location.href = "https://collabbayadmin.com/plans";
    }}
    title="View your plan"
    aria-label={`My account. ${
      isSubscriber ? "Standard access" : "Free plan"
    }. Click to view plans.`}
  >
    <span className="accountPlanCopy">
      <span className="accountPlanLabel">My account</span>

      <span className="accountPlanName">
        {isSubscriber ? "Standard Plan • Pro Access" : "Free Access Plan "}
      </span>
    </span>
  </button>
)}
</div>

<div className="badge">
  <BoltIcon />
  Grow with creator visits
</div>
            </div>
          </div>

          {recentOnline?.length > 0 && (
            <div className="recent">
              <span>Recently online</span>
              <div className="avatars">
                {recentOnline.slice(0, 3).map((u, idx) => (
                  <div className="av" key={idx} style={{ zIndex: 3 - idx }}>
                    <img alt="" src={u?.ProfileImage} />
                    {idx === 0 && <span className="greenDot" />}
                  </div>
                ))}
                {recentCount > 3 && (
                  <span className="plus">+{recentCount - 3}</span>
                )}
              </div>
            </div>
          )}
        </div>



{suggestedListing && (
  <div className="suggestedListingInfoCard">
    <div className="suggestedListingInfoIcon">i</div>

    <div className="suggestedListingInfoText">
      <div className="suggestedListingInfoTitle">
        We’ve prepared a suggested offer for you
      </div>

      <div className="suggestedListingInfoSub">
        Our team has drafted an offer you can edit and post in a few clicks.
        {suggestedListing?.NonCreditOffer ? (
          <> Suggested: <strong>{suggestedListing.NonCreditOffer}</strong></>
        ) : null}
      </div>
    </div>

<button
  className="suggestedListingInfoBtn"
  onClick={() => {
    setShowSuggestedListingModal(false);

    window.location.href =
      `https://collabbayadmin.com/Introduction.html?Brand=${encodeURIComponent(userData.Username)}`;
  }}
>
  View offer
  <ChevronRightIcon size={16} />
</button>
  </div>
)}

        {/* Upgrade strip in main (if logged in but not subscribed) */}
        {userData?.Username && !isAuthenticated && (
          <div className="card upgradeStrip">
            <div className="upgradeStripText">
              <div className="upgradeStripTitle">Unlock full access</div>
              <div className="upgradeStripSub">
                View your calendar, creator profiles and activity feed without
                limits.
              </div>
            </div>
            <button className="upgradeStripBtn" onClick={openSubscribe}>
              Upgrade now
              <ChevronRightIcon size={16} />
            </button>
          </div>
        )}

        {/* Grid */}
        <div className="grid">
          {/* Left column */}
          <div className="col">
            {/* Recap banner (video + venue code + CTA) */}
            <div className="recap">
              <div className="recapTile recapVideo" aria-label="Intro video">
                <video autoPlay muted playsInline loop>
                  <source
                    src="https://collabbayadmin.com/Admin%20Web%20Intro%20%20Collabbay%20App%20(1).mp4"
                    type="video/mp4"
                  />
                </video>
              </div>

              <div className="recapTile recapCard">
                <div className="recapText">
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 8,
                    }}
                  >
                    <div className="recapLabel">Your venue code is</div>
                    <button
                      type="button"
                      className="infoBtn"
                      onClick={() => setShowVenueCodeInfo(true)}
                      aria-label="What is this code?"
                    >
                      i
                    </button>
                  </div>
                  <div className="recapValue">{venueCode || "--"}</div>
                </div>

            <div
  style={{
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-end",
    gap: 8,
  }}
>
  <button
    className="recapCTA"
    onClick={() => navigateTo("MyOffers")}
    title="Go to all collabs"
    style={{
      background: "#fdf05d",
    }}
  >
    Go to all collabs
    <span className="countPill">
      {typeof totalCollabCount === "number"
        ? totalCollabCount
        : 0}
    </span>
    <ChevronRightIcon size={18} />
  </button>



<button
  type="button"
  onClick={() => navigateTo("MyReviews")}
  style={{
    border: "1px solid rgba(15,23,42,0.14)",
    background: "#ffffff",
    color: "#111827",
    borderRadius: 999,
    padding: "9px 13px",
    fontSize: 13,
    fontWeight: 700,
    cursor: "pointer",
    display: "inline-flex",
    alignItems: "center",
    gap: 8,
    boxShadow: "0 8px 18px rgba(15,23,42,0.06)",
  }}
>
  Download positive reviews
  <span className="newBadge">New</span>
  <ChevronRightIcon size={15} />
</button>
</div>
              </div>
            </div>

            {/* Collab calendar */}
            <div className="card">
              <div className="cardHeader">
                <div className="cardTitle">My Collabs</div>
              </div>

              <div className="controlsBar">
                <div className="searchBox" title="Search by creator name">
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="#bbb"
                    aria-hidden
                  >
                    <path d="M15.5 14h-.79l-.28-.27A6.471 6.471 0 0016 9.5 6.5 6.5 0 109.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 5 1.5-1.5-5-5zM9.5 14A4.5 4.5 0 119.5 5a4.5 4.5 0 010 9z" />
                  </svg>
                  <input
                    placeholder="Search creator…"
                    value={searchName}
                    onChange={(e) => setSearchName(e.target.value)}
                  />
                  {(searchName || statusFilter !== "All") && (
                    <button
                      className="clearBtn"
                      onClick={() => {
                        setSearchName("");
                        setStatusFilter("All");
                      }}
                    >
                      Clear
                    </button>
                  )}
                </div>

                <select
                  className="sortSelect"
                  value={sortMode}
                  onChange={(e) => setSortMode(e.target.value)}
                  title="Sort"
                >
                  <option value="Soonest">Sort: Soonest</option>
                  <option value="Latest">Sort: Latest</option>
                  <option value="Created-Newest">Sort: Created (Newest)</option>
                  <option value="Created-Oldest">Sort: Created (Oldest)</option>
                </select>
              </div>

          

          {loadingCollabs || loadingDummyBookingPrompt ? (
  <div className="muted">Loading…</div>
) : (
  <div className="list">

    {showDummyBookingPrompt && (
      <div
        className="row"
        onClick={() => navigation.navigate("BookingTutorial")}
        title="Open booking tutorial"
        style={{ position: "relative" }}
      >
        <div
          style={{
            position: "absolute",
            top: -8,
            left: 14,
            background: "#FDF05D",
            color: "#000",
            fontWeight: 800,
            borderRadius: 999,
            padding: "4px 9px",
            fontSize: 11,
            zIndex: 5,
          }}
        >
          TUTORIAL
        </div>

        <div className="rowTop">
          {(() => {
            const { main, when } = formatDateParts(dummyBookingDate);

            return (
              <div className="dateWrap">
                <span className="dateTxt">{main}</span>

                {when && (
                  <span className="whenPill">
                    <EmphasizedWhen text={when} />
                  </span>
                )}

                <div
                  style={{
                    backgroundColor: "#f3f4f6",
                    borderRadius: 8,
                    padding: "4px 8px",
                    fontSize: 12,
                    color: "#4b5563",
                  }}
                >
                  20K–50K Followers
                </div>
              </div>
            );
          })()}

          <div className="status pending">
            <DotIcon />
            Pending
          </div>
        </div>

        <div className="nameRow">
          <div className="avatar">
            <img
              alt=""
              src="https://collabbay.com/DefaultProfileIcon.png"
            />
          </div>

          <div className="promoter">
            Example Creator
          </div>
        </div>

        <div className="chipRow">
          <div className="chip offerChip">
            Complimentary meal for two
          </div>
        </div>

        <div className="rowChevron">
          <ChevronRightIcon size={22} />
        </div>
      </div>
    )}

    {!showDummyBookingPrompt &&
      displayCollabs.length === 0 && (
        <div className="muted">
          No requests yet.
        </div>
      )}

    {filteredCollabs.map((c, idx) => {
             const s = getStatus(c);
const isProposal = String(c?.IsProposal || "").toUpperCase() === "Y";

const isFreeRow =
  !isAuthenticated &&
  trialFreeCollabID &&
  c?.CollabID === trialFreeCollabID;

const shouldBlur = !isAuthenticated && !isFreeRow;
const promoterName = c?.Promoter || "";
const isUnseen =
  String(c?.HasBrandSeenOffer || "").trim().toUpperCase() !== "Y";

                    return (
                      <div
                        key={c?.CollabID || idx}
                        className={`row ${isFreeRow ? "free" : ""} ${isProposal ? "proposal" : ""}`}
                        onClick={() => handleRowClick(c)}
                        title="Open collab"
                      >

                        {isUnseen && (
  <div
    className="unseenRequestBadge"
    title="New booking request"
  >
    1
  </div>
)}
                        {isFreeRow && (
                          <div
                            style={{
                              position: "absolute",
                              top: -8,
                              left: 14,
                              background: "var(--ok)",
                              color: "#000",
                              fontWeight: 800,
                              borderRadius: 999,
                              padding: "4px 8px",
                              fontSize: 12,
                            }}
                          >
                            Unlocked for you
                          </div>
                        )}

                        {isProposal && (
  <div className="proposalBadge">
  ✦ Proposal
  </div>
)}


{isProposal && (
  <div className="proposalInfo">
    Curated for you
  </div>
)}

                        <div className="rowTop">
                          {(() => {
                            const { main, when } = formatDateParts(
                              c?.CreditAvailableStart
                            );
                            return (
                              <div className="dateWrap">
                                <span className="dateTxt">{main}</span>
                                {when && (
                                  <span className="whenPill">
                                    <EmphasizedWhen text={when} />
                                  </span>
                                )}

                                {c?.PlatformFollowers && (
                                  <div
                                    style={{
                                      display: "inline-block",
                                      marginTop: 4,
                                      backgroundColor: "#f3f4f6",
                                      borderRadius: 8,
                                      padding: "4px 8px",
                                      fontSize: 12,
                                      color: "#4b5563",
                                      border:
                                        "1px solid rgba(148,163,184,0.35)",
                                    }}
                                  >
                                    {getFollowerRange(
                                      parseFollowers(c.PlatformFollowers)
                                    )}
                                  </div>
                                )}
                              </div>
                            );
                          })()}
             <div
  style={{
    display: "flex",
    alignItems: "center",
    gap: 8,
  }}
>


  {s === "Pending" && (
  <button
    type="button"
    disabled={hidingCollabID === c?.CollabID}
    onClick={(e) =>
      handleNotInterested(e, c?.CollabID)
    }
    style={{
      border: "1px solid #93c5fd",
      background: "#eff6ff",
      color: "#1e40af",
      borderRadius: 999,
      padding: "6px 10px",
      fontSize: 15,
      fontWeight: 700,
      cursor:
        hidingCollabID === c?.CollabID
          ? "default"
          : "pointer",
      opacity:
        hidingCollabID === c?.CollabID
          ? 0.5
          : 1,
      display: "inline-flex",
      alignItems: "center",
      gap: 5,
    }}
  >
    <svg
      width="14"
      height="14"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94" />
      <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19" />
      <path d="M14.12 14.12A3 3 0 0 1 9.88 9.88" />
      <line x1="1" y1="1" x2="23" y2="23" />
    </svg>

    {hidingCollabID === c?.CollabID
      ? "Hiding..."
      : "Hide?"}
  </button>
)}
  <div className={`status ${statusClass(s)}`}>
    <DotIcon />
    {s}
  </div>
</div>
                        </div>

                        <div className="nameRow">
                          <div
                            className={`avatar ${
                              shouldBlur ? "blurredAvatar" : ""
                            }`}
                          >
                            <img
                              alt=""
                              src={
                                c?.PromoterProfileImage &&
                                c.PromoterProfileImage.trim() !== ""
                                  ? c.PromoterProfileImage
                                  : "https://collabbayadmin.com/defaults/avatar-placeholder.png"
                              }
                            />
                          </div>
                          <div
                            className={`promoter ${
                              shouldBlur ? "blurredName" : ""
                            }`}
                          >
                            {promoterName}
                          </div>
                        </div>

                        <div className="chipRow">
                          {c?.NonCreditOffer && (
                            <div className="chip offerChip">
                              <span className="label"></span>
                              {c.NonCreditOffer.length > 60
                                ? c.NonCreditOffer.slice(0, 60) + "…"
                                : c.NonCreditOffer}
                            </div>
                          )}

                          {c?.OnBehalfOf?.trim() && (
                            <div className="chip clientChip">
                              <span className="label">Client</span> |{" "}
                              {c.OnBehalfOf}
                            </div>
                          )}
                        </div>

                        {/* Big chevron on the right */}
                        <div className="rowChevron">
                          <ChevronRightIcon size={22} />
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          </div>

          {/* Right column */}
          <div className="col">
            {/* No offers CTA */}
            {userData?.Username && brandListings.length === 0 && (
              <div className="card">
                <div
                  style={{
                    background: "var(--brand)",
                    color: "#000",
                    borderRadius: 14,
                    padding: 16,
                  }}
                >
                  <div
                    style={{
                      fontWeight: 800,
                      fontSize: 18,
                      marginBottom: 4,
                    }}
                  >
                    Post an offer to start taking bookings
                  </div>
                  <div className="muted" style={{ color: "#000", opacity: 0.65 }}>
                    You're one step away.
                  </div>
                  <div style={{ height: 10 }} />
                  <button
                    className="ctaBtn"
                    onClick={() => navigateTo("GuidedOfferSetup")}
                  >
                    Create an Offer
                  </button>{" "}
                  <button
                    className="ghostBtn"
                    onClick={() => navigateTo("NotificationsPage")}
                  >
                    Notifications
                  </button>
                </div>
              </div>
            )}

            {/* My Offers */}
            <div className="card">
              <div className="cardHeader">
                <div className="cardTitle">My Offers</div>
                <button className="linkBtn" onClick={() => navigateTo("MyOffers")}>
                  Go to dashboard{" "}
                  <ChevronRightIcon size={16} color="#000000" />
                </button>
              </div>

              {brandListings.length === 0 ? (
                <div className="muted">No offers yet. Click “Create offer”.</div>
              ) : (
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "1fr",
                    gap: 12,
                  }}
                >
                  {brandListings.map((item, idx) => (
                    <div className="offer" key={idx}>
                      <div className="offerImg">
                        <img alt="" src={getCoverImage(item.LogoImage)} />
                        {Number(listingViewsById?.[item.ListingID] || 0) > 0 && (
  <div className="viewsBadge" title="Offer views">
    <EyeIcon size={14} />
    <span>{listingViewsById[item.ListingID]} views</span>
  </div>
)}

                        <button
                          className="editFab"
                          onClick={() => handleEditBanner(item.ListingID)}
                        >
                          <EditIcon />
                        </button>
                        {!item.LogoImage ||
                        item.LogoImage ===
                          "https://collabbayadmin.com/NoListingImage.jpg" ? (
                          <div
                            style={{
                              position: "absolute",
                              bottom: 8,
                              left: 8,
                              background: "#eb5757",
                              color: "#fff",
                              borderRadius: 999,
                              padding: "6px 10px",
                              fontSize: 12,
                              fontWeight: 800,
                            }}
                          >
                            Add a banner image
                          </div>
                        ) : null}
                      </div>
                      <div className="offerBody">
                        <div className="offerSub">
                          Created {prettyShortDate(item.Created_At)}
                        </div>
                        <div className="offerTitle" style={{ margin: "6px 0" }}>
                          {item.AdHeader?.length > 200
                            ? item.AdHeader.slice(0, 200) + "…"
                            : item.AdHeader}
                        </div>

                        {item.OnBehalfOf && item.OnBehalfOf.trim() !== "" && (
                          <div className="chip" style={{ marginBottom: 8 }}>
                            Client | {item.OnBehalfOf}
                          </div>
                        )}

                        <div className="offerSub" style={{ marginBottom: 10 }}>
                          {(item.ListingDescription || "").length > 120
                            ? item.ListingDescription.slice(0, 120) + "…"
                            : item.ListingDescription}
                          <br />
                          <strong>{item.Location}</strong>
                        </div>

                        {item.PauseLiveToggle === "Live" ? (
                          <span className="live">
                            <DotIcon /> Live
                          </span>
                        ) : (
                          <span className="paused">
                            <DotIcon /> Paused
                          </span>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>

            {/* Missed Bookings Section */}
            {missedCollabs.length > 0 && (
              <div className="card">
                <div className="cardHeader">
                  <div className="cardTitle">Missed These Bookings?</div>
                </div>

                <div className="list">
                  {missedCollabs.map((m, i) => {
                    const blurred = !isAuthenticated;

                    const handleClick = () => {
                      if (!isAuthenticated) {
                        openPreviewBooking(m);
                      } else {
                        navigation.navigate("BookingRequest", {
                          CollabID: m.CollabID,
                        });
                      }
                    };

                    return (
                      <div
                        key={i}
                        className="row"
                        onClick={handleClick}
                        style={{
                          position: "relative",
                          background: "rgba(255,255,255,0.97)",
                          cursor: "pointer",
                        }}
                      >
                        <div className="nameRow">
                          <div
                            className={`avatar ${
                              blurred ? "blurredAvatar" : ""
                            }`}
                          >
                            <img
                              alt=""
                              src={
                                m.PromoterProfileImage ||
                                "https://collabbayadmin.com/defaults/avatar-placeholder.png"
                              }
                            />
                          </div>
                          <div
                            className={`promoter ${
                              blurred ? "blurredName" : ""
                            }`}
                          >
                            {m.Promoter}
                          </div>
                        </div>

                        <div style={{ fontSize: 12, color: "#6b7280" }}>
                          Requested to visit on {formatDate(m.CreditAvailableStart)}
                        </div>

                        <div
                          style={{
                            display: "inline-block",
                            marginTop: 4,
                            backgroundColor: "#f3f4f6",
                            borderRadius: 8,
                            padding: "4px 8px",
                            fontSize: 12,
                            color: "#4b5563",
                            border: "1px solid rgba(148,163,184,0.35)",
                          }}
                        >
                          {getFollowerRange(parseFollowers(m.PlatformFollowers))}
                        </div>

                        {m?.OnBehalfOf?.trim() && (
                          <div
                            style={{
                              display: "inline-flex",
                              alignItems: "center",
                              gap: 6,
                              marginTop: 6,
                              background: "rgba(249,250,251,1)",
                              border: "1px solid #d1d5db",
                              borderRadius: 12,
                              padding: "6px 10px",
                              fontSize: 13,
                              fontWeight: 600,
                              color: "#111827",
                              width: "fit-content",
                            }}
                          >
                            <span style={{ fontWeight: 800, opacity: 0.9 }}>
                              Client
                            </span>{" "}
                            | {m.OnBehalfOf}
                          </div>
                        )}

                        {/* Big chevron on right of missed booking row */}
                        <div className="rowChevron">
                          <ChevronRightIcon size={22} />
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            )}

            {/* Content due (RAG) */}
            <div className="card">
              <div className="cardHeader">
                <div className="cardTitle">Content due</div>
              </div>
              {loadingRAG ? (
                <div className="muted">Loading…</div>
              ) : ragItems.length === 0 ? (
                <div className="muted">No pending content.</div>
              ) : (
                <div className="rag">
                  {ragItems.map((x, i) => {
                    const due = new Date(x.LatestDeliveryDate);
                    const daysLeft = Math.floor(
                      (Date.UTC(due.getFullYear(), due.getMonth(), due.getDate()) -
                        Date.UTC(
                          new Date().getFullYear(),
                          new Date().getMonth(),
                          new Date().getDate()
                        )) /
                        (1000 * 60 * 60 * 24)
                    );
                    const isRed = x.Status === "RED";
                    return (
                      <div
                        key={i}
                        className={`ragItem ${isRed ? "red" : "yellow"}`}
                      >
                        <div className="ragTitle">
                          {isRed
                            ? "Content overdue."
                            : `Pending content, due in ${daysLeft} day${
                                daysLeft === 1 ? "" : "s"
                              }`}
                        </div>
                        <div className="ragSub">from {x.Promoter}</div>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          </div>
        </div>

        {/* “Influencer at your venue now?” alert */}
        {alertCollabs.length > 0 && currentCollab && (
          <div className="card" style={{ border: "1px solid var(--brand)" }}>
            <div className="cardHeader" style={{ alignItems: "center", gap: 10 }}>
              <div className="cardTitle">Influencer at your venue now?</div>
              <button className="ctaBtn" onClick={() => setShowCollabModal(true)}>
                View instructions
              </button>
            </div>
            <div className="muted">You have a scheduled collab in the current window.</div>
          </div>
        )}
      </main>

      {/* Login prompt */}
      {showLoginPrompt && !userData?.Username && (
        <Modal onClose={() => {}}>
          <h3>
            Join Collabbay for Business<span className="brand">.</span>
          </h3>
          <p className="muted">
            Access 480+ creators and 20m+ combined followers. Start posting
            offers and accept bookings.
          </p>
          <div className="hr" />
          <div className="grid2">
            <button
              className="ghostBtn"
              onClick={() =>
                (window.location.href = "https://collabbayadmin.com/SignIn")
              }
            >
              Log in
            </button>
            <button
              className="ctaBtn"
              onClick={() =>
                (window.location.href = "https://collabbayadmin.com/SignUp")
              }
            >
              Create account
            </button>
          </div>
        </Modal>
      )}

      {/* Venue code info modal */}
      {showVenueCodeInfo && (
        <Modal onClose={() => setShowVenueCodeInfo(false)}>
          <h3>Using your venue code</h3>
          <p className="muted">
            Give this code to influencers when they visit so that they can
            log their visit on their app.
          </p>
        </Modal>
      )}

      {/* Collab now modal */}
      {showCollabModal && currentCollab && (
        <Modal onClose={() => setShowCollabModal(false)}>
          <div className="cardHeader" style={{ marginBottom: 6 }}>
            <h3 style={{ margin: 0 }}>Are you collabing now?</h3>
          </div>
          <p className="muted" style={{ marginTop: 0 }}>
            You have an upcoming collab with{" "}
            <strong>{currentCollab?.BrandName || "brand"}</strong>.
          </p>
          <div className="hr" />
          <ol style={{ lineHeight: 1.8, margin: 0, paddingLeft: 18 }}>
            <li>Welcome the creator. 👋</li>
            <li>Provide the agreed offer or service. 🎉</li>
            <li>The creator will prepare their content on-site. 🔗</li>
            <li>Scan the creator’s QR code before they leave to confirm. 🗺</li>
            <li>Await the content upload as per the agreed timeline. 📤</li>
          </ol>
          <div className="hr" />
          <div style={{ display: "flex", justifyContent: "flex-end", gap: 10 }}>
            <button className="ghostBtn" onClick={() => setShowCollabModal(false)}>
              Close
            </button>
            <button
              className="ctaBtn"
              onClick={() =>
                navigation.navigate("BookingRequest", {
                  CollabID: currentCollab.CollabID,
                })
              }
            >
              Go to Collab
            </button>
          </div>
        </Modal>
          )}

      {/* Live customer query modal */}
      {showCustomerQueryModal && (
        <div className="modalOverlay" role="dialog" aria-modal="true">
          <div className="customerSupportModal">
            <button
              type="button"
              className="customerSupportClose"
              aria-label="Close customer support"
              onClick={closeCustomerQueryModal}
            >
              ×
            </button>

            <div className="customerSupportTop">
              <div className="customerSupportIcon">
                <svg width="21" height="21" viewBox="0 0 24 24" fill="none" aria-hidden>
                  <path
                    d="M4 5.5C4 4.12 5.12 3 6.5 3h11C18.88 3 20 4.12 20 5.5v7C20 13.88 18.88 15 17.5 15H9l-5 4V5.5Z"
                    stroke="#FDF05D"
                    strokeWidth="2"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M8 8h8M8 11h5"
                    stroke="#FDF05D"
                    strokeWidth="2"
                    strokeLinecap="round"
                  />
                </svg>
              </div>

              <div>
                <h3 className="customerSupportTitle">
                  How can we help? Don't hesitate to get in touch.
                </h3>
                <p className="customerSupportSub">
                  Need a hand? Send a quick message straight to our team, we'll open a support case and follow up over email.
                </p>
              </div>
            </div>

            {customerQuerySuccess ? (
              <div className="customerSupportSuccess">
                {customerQuerySuccess}

                {customerQueryRef ? (
                  <div className="customerSupportRef">
                    Reference: {customerQueryRef}
                  </div>
                ) : null}

                <div style={{ marginTop: 10 }}>
                  If your query is usage related,{" "}
                  <a
                    className="customerSupportFaq"
                    href="https://collabbayadmin.com/FAQs"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    here's a quick tutorial
                  </a>
                  .
                </div>
              </div>
            ) : (
              <form className="customerSupportForm" onSubmit={submitCustomerQuery}>
                <div>
                  <label className="customerSupportLabel">
                    Message
                  </label>
                  <textarea
                    className="customerSupportTextarea"
                    value={customerQueryMessage}
                    onChange={(e) => setCustomerQueryMessage(e.target.value)}
                    placeholder="Tell us what you need help with..."
                    maxLength={1500}
                  />
                </div>

                <div>
                  <label className="customerSupportLabel">
                    Mobile number
                    <span className="customerSupportRecommended">Recommended</span>
                  </label>
                  <input
                    className="customerSupportInput"
                    type="tel"
                    value={customerQueryPhone}
                    onChange={(e) => setCustomerQueryPhone(e.target.value)}
                    placeholder="e.g. 07123 456789"
                    maxLength={25}
                  />
                </div>

                {customerQueryError ? (
                  <div className="customerSupportError">
                    {customerQueryError}
                  </div>
                ) : null}

                <button
                  type="submit"
                  className="customerSupportSubmit"
                  disabled={customerQuerySubmitting}
                >
                  {customerQuerySubmitting ? "Sending..." : "Send message"}
                </button>
              </form>
            )}
          </div>
        </div>
      )}



{/* Clara drawer */}
{showClara && isSubscriber && (
  <div
    className="claraOverlay"
    onClick={closeClara}
  >
    <aside
      className="claraDrawer"
      onClick={(e) => e.stopPropagation()}
      role="dialog"
      aria-modal="true"
      aria-label="Clara AI assistant"
    >
      <div className="claraDrawerHeader">

        <div className="claraDrawerIdentity">

          <div className="claraDrawerLogo">
            <ClaraIcon size={21} />
          </div>

          <div>
            <div className="claraDrawerTitleRow">
              <span className="claraDrawerTitle">
                Clara™
              </span>

              <span className="claraLiveDot" />
            </div>

            <div className="claraDrawerSubtitle">
              {userData.Username}'s AI assistant
            </div>
          </div>

        </div>

        <div className="claraDrawerControls">

          <button
            type="button"
            className="claraDrawerControl"
            onClick={openClaraInfo}
            title="What can Clara do?"
            aria-label="About Clara"
          >
            i
          </button>

          <button
            type="button"
            className="claraDrawerControl"
            onClick={closeClara}
            title="Close Clara"
            aria-label="Close Clara"
          >
            ×
          </button>

        </div>
      </div>

      <div className="claraIframeWrap">
        <iframe
          src="https://collabbayadmin.com/Clara"
          title="Clara"
          className="claraIframe"
          allow="clipboard-write"
        />
      </div>

    </aside>
  </div>
)}


{/* Clara information modal */}
{showClaraInfo && isSubscriber && (
  <div
    className="claraInfoOverlay"
    onClick={() => setShowClaraInfo(false)}
  >
    <div
      className="claraInfoModal"
      onClick={(e) => e.stopPropagation()}
      role="dialog"
      aria-modal="true"
      aria-label="About Clara"
    >

      <button
        type="button"
        className="claraInfoClose"
        onClick={() => setShowClaraInfo(false)}
        aria-label="Close"
      >
        ×
      </button>

      <div className="claraInfoHeroIcon">
        <ClaraIcon size={26} />
      </div>

      <span className="claraNewBadge">
        NEW
      </span>

      <h2>Meet Clara™</h2>

      <p className="claraInfoLead">
        Your AI influencer manager, built into Collabbay.
      </p>

      <div className="claraFeatureList">

        <div className="claraFeature">
          <span className="claraFeatureIcon">✦</span>

          <div>
            <strong>Find suited creators</strong>
            <span>
              Get recommendations based on your venue,
              activity and goals.
            </span>
          </div>
        </div>

        <div className="claraFeature">
          <span className="claraFeatureIcon">✦</span>

          <div>
            <strong>Manage your collabs</strong>
            <span>
              Keep on top of bookings, visits, conversations
              and upcoming activity.
            </span>
          </div>
        </div>

        <div className="claraFeature">
          <span className="claraFeatureIcon">✦</span>

          <div>
            <strong>Advise on creators</strong>
            <span>
              Ask Clara about creators, offers and what
              your venue should do next.
            </span>
          </div>
        </div>

        <div className="claraFeature">
          <span className="claraFeatureIcon">✦</span>

          <div>
            <strong>Learn your business</strong>
            <span>
              Clara uses your Collabbay activity and preferences
              to provide more relevant help.
            </span>
          </div>
        </div>

      </div>

      <button
        type="button"
        className="claraInfoCTA"
        onClick={() => {
          setShowClaraInfo(false);
          openClara();
        }}
      >
        <span>Chat with Clara</span>
        <span>→</span>
      </button>

      <div className="claraInfoDisclaimer">
        Clara can make mistakes. You're always in control.
      </div>

    </div>
  </div>
)}

    </div>
  );
}







/* ---------------- Icons ---------------- */
function DotIcon() {
  return (
    <svg width="12" height="12" viewBox="0 0 24 24" fill="#fff" aria-hidden>
      <circle cx="12" cy="12" r="6" />
    </svg>
  );
}
function BoltIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="#FFD400" aria-hidden>
      <path d="M13 2L3 14h7l-1 8 10-12h-7l1-8z" />
    </svg>
  );
}
function LaptopIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="#fff" aria-hidden>
      <path d="M4 5h16v10H4V5zm-2 12h20v2H2v-2z" />
    </svg>
  );
}
function SearchIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="#fff" aria-hidden>
      <path d="M15.5 14h-.79l-.28-.27A6.471 6.471 0 0016 9.5 6.5 6.5 0 109.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 5 1.5-1.5-5-5zM9.5 14A4.5 4.5 0 119.5 5a4.5 4.5 0 010 9z" />
    </svg>
  );
}
function CalendarIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="#fff" aria-hidden>
      <path d="M7 2h2v2h6V2h2v2h3v18H4V4h3V2zm13 8H6v10h14V10z" />
    </svg>
  );
}
function ChatIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="#fff" aria-hidden>
      <path d="M2 3h20v14H6l-4 4V3z" />
    </svg>
  );
}


function ClaraIcon({ size = 16 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden
    >
      <path
        d="M12 2.8l1.65 5.02L18.8 9.5l-5.15 1.68L12 16.2l-1.65-5.02L5.2 9.5l5.15-1.68L12 2.8Z"
        fill="currentColor"
      />

      <path
        d="M18.4 14.2l.82 2.48 2.48.82-2.48.82-.82 2.48-.82-2.48-2.48-.82 2.48-.82.82-2.48Z"
        fill="currentColor"
        opacity=".72"
      />
    </svg>
  );
}



function UserIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="#fff" aria-hidden>
      <path d="M12 2a5 5 0 110 10 5 5 0 010-10zm0 12c4.418 0 8 2.239 8 5v3H4v-3c0-2.761 3.582-5 8-5z" />
    </svg>
  );
}

function ContentIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="#fff" aria-hidden>
      <path d="M4 4h16v2H4V4zm0 5h16v2H4V9zm0 5h10v2H4v-2zm0 5h10v2H4v-2z" />
    </svg>
  );
}



function ChevronRightIcon({ size = 20 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden
    >
      <polyline
        points="9 6 15 12 9 18"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
function EditIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="#fff" aria-hidden>
      <path d="M3 17.25V21h3.75l11-11L14 6.25l-11 11zM21.41 6.34l-3.75-3.75-2.12 2.12 3.75 3.75 2.12-2.12z" />
    </svg>
  );
}
function MapIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="#FDF05D" aria-hidden>
      <path d="M9 3l6 2.25L21 3v15l-6 2.25L9 18 3 20V5l6-2zM9 5.14v11.72l6 2.14V7.28L9 5.14z" />
    </svg>
  );
}

function EyeIcon({ size = 14 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden
    >
      <path
        d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12Z"
        stroke="#fff"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <circle cx="12" cy="12" r="3" stroke="#fff" strokeWidth="2" />
    </svg>
  );
}


/* ---------------- Small helpers ---------------- */
function prettyShortDate(dateString) {
  const d = new Date(dateString);
  if (isNaN(d)) return "";
  const day = d.getDate();
  const month = d.toLocaleString("default", { month: "short" });
  const year = d.getFullYear();
  const nowYear = new Date().getFullYear();
  return `${day} ${month}${year !== nowYear ? `, ${year}` : ""}`;
}

/* ---------------- Modal ---------------- */
function Modal({ children, onClose }) {
  return (
    <div className="modalOverlay" role="dialog" aria-modal="true">
      <div className="modal">
        <div className="modalHeader">
          <span />
          <button className="x" aria-label="Close" onClick={onClose}>
            ×
          </button>
        </div>
        <div>{children}</div>
      </div>
    </div>
  );
}
